<--开方页面-->
<template>
    <div>
        <el-container style="height: 100%;padding: 0;">
            <el-aside width="320px">
                <div class="search-box">
                    <el-input size="small"
                              style="width: 214px"
                              placeholder="请输入患者姓名"
                              v-model="userName"
                              suffix-icon="el-icon-search"
                    ></el-input>
                    <a target="_blank" :href="cardUrl">
                        <el-button size="small" type="text" style="margin-left: 10px;width: 56px;">邀请患者</el-button>
                    </a>
                </div>
                <div style="width: 300px;margin: 10px;">
                    <el-radio-group v-model="rarelyUsed" size="small" @change="getData">
                        <el-radio-button label="0">
                            <div style="width: 95px !important;">常用</div>
                        </el-radio-button>
                        <el-radio-button label="1">
                            <div style="width: 95px !important;">不常用</div>
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="person_list"
                     @dblclick="selectPatient(item)"
                     v-if="patientData.length !== 0"
                     v-for="(item,index) in patientData"
                     :key="index"
                     @mouseover="isHover = item.id"
                     @mouseout="isHover = ''"
                     :class="{active : active === item.id}"
                >
                    <div class="person">
                        <div class="person_p" :style="{backgroundImage: 'url(' + item.headImage +')'}"></div>
                        <div class="person_i">
                            <p>{{ item.realName }}</p>
                            <span v-if="item.sex === '1'">男</span>
                            <span v-else-if="item.sex === '2'">女</span>
                            <span v-else>无</span>
                            <span class="mr30"
                                  v-if="item.age==undefined || item.age=='null' ||item.age==null||item.age==''">0岁</span>
                            <span class="mr30" v-else>{{item.age}}岁</span>
                        </div>
                    </div>
                    <!-- <div class="patient-box-in" style="margin-top: 8px;justify-content: space-between">
                         <div>{{ item.mobile }}</div>
                         <div style="margin: -10px 10px"
                              v-show="isHover === item.patientId || active === item.patientId">
                             &lt;!&ndash;                            <el-button type="text" @click="seeRecord(item)">就诊记录</el-button>
                                                         <el-button type="text" @click="selectPatient(item)">录入</el-button>&ndash;&gt;
                         </div>
                     </div>-->
                </div>
                <!--                <div v-if="patientData.length === 0" style="font-size: 14px;margin-top: 200px;color:rgba(102,102,102,1);">暂无患者</div>-->
            </el-aside>
            <!--            <div v-if="patientData.length === 0" style="font-size: 14px;margin: 200px 500px;color:rgba(102,102,102,1);">暂无患者</div>-->
            <el-aside width="80%">
            <div>
                <div style="background: rgba(248,248,248,1);padding: 10px 20px 0 20px;">
                    <div class="flex-box" style="justify-content: space-between;align-items: center;">
                        <div class="dialog-set">
                            <div style="min-width: 100px">科室: {{ administrativeOffice }}</div>
                            <span style="margin-left: 50px">日期: {{ time }}</span>
                        </div>
                        <div>
                            <span style="margin-top: -20px">总价:<span class="money">¥ {{price}}</span></span>

                            <div class="footer_btn" style="float: right;">
                                <span class="print_btn"
                                      style="color: #666666;background-color: #FFFFFF;border: 1px solid #E0E0E0;"
                                      @click="printVisible=true" v-if="medicineType==1">预览<br>打印</span>
                                <span class="finish_btn" style="color: #FFFFFF; background: linear-gradient(135deg, #FFC692 0%, #FF9459 100%);
                                box-shadow: 2px 2px 12px 0px #FFBDA2;" @click="finishWork">完成<br>就诊</span>
                            </div>

                        </div>
                    </div>
                    <el-form :model="OrderMaster" :rules="rule" ref="diagnose1">
                        <div class="flex-box">
                            <el-form-item label="姓名:" class="flex-box" prop="patientName">
                                <el-input size="small" style="width: 100px;"
                                          v-model="OrderMaster.patientName"></el-input>
                            </el-form-item>
                            <el-form-item label="性别:" class="flex-box" style="margin-left: 40px"
                                          prop="patientSex">
                                <el-radio-group v-model="OrderMaster.patientSex" size="small">
                                    <el-radio-button label="1">
                                        男
                                    </el-radio-button>
                                    <el-radio-button label="2">
                                        女
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="是否怀孕:" class="flex-box" style="margin-left: 40px"
                                          prop="patientPregnant" v-if="OrderMaster.patientSex==2">
                                <el-radio-group v-model="OrderMaster.patientPregnant" size="small">
                                    <el-radio-button label="1">
                                        有孕
                                    </el-radio-button>
                                    <el-radio-button label="2">
                                        未孕
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="年龄:" class="flex-box" style="margin-left: 40px" prop="patientAge">
                                <el-input size="small" style="width: 100px;"
                                          @keydown="handleInput" onkeyup="this.value=this.value.replace(/[^0-9.]/g,'')"
                                          v-model.number="OrderMaster.patientAge"
                                          　></el-input>
                            </el-form-item>

                        </div>
                    </el-form>
                    <el-form :model="OrderMaster" :rules="rule" ref="diagnose2" label-width ="100px">
                        <div class="flex-box" >
                            <el-form-item label="患者主述:" 
                                          prop="patientComplaint">
                                <el-input size="small" style="width: 280px;"class="flex-box"
                                          v-model="OrderMaster.patientComplaint"></el-input>
                            </el-form-item>
                            <el-form-item label="临床诊断:" 
                                          prop="doctorDiagnose">
                                <el-input size="small" style="width: 280px"class="flex-box"
                                          v-model="OrderMaster.doctorDiagnose"></el-input>
                            </el-form-item>
                            <el-form-item label="医嘱:"  prop="doctorAdvice">
                                <el-input size="small" style="width: 280px;"class="flex-box"
                                          v-model="OrderMaster.doctorAdvice"></el-input>
                            </el-form-item>
                            
                        </div>
                        
                       
                    </el-form>
                </div>
                <div style="margin-top: -15px;padding: 0 20px">

                    <div class="select-box">
                        <div class="select" @click="medicineTypeClick('1')"
                             :class="{selectActive1 : medicineType === '1'}">中草药
                        </div>
                        <div class="select" @click="medicineTypeClick('2')"
                             :class="{selectActive1 : medicineType === '2'}">西药/中成药
                        </div>
                    </div>
                    <div v-if="medicineType==='1'">
                        <div class="flex-box">
                        <span>处方类型:
                            <el-select :disabled="OrderMaster.slaves[0].items.length > 0 "
                                       size="small" v-model="OrderMaster.typeCode"
                                       placeholder="请选择类型" style="width: 120px;margin-right: 10px"
                                       @change="getPharmacy">
                                <el-option
                                        v-for="item in dosageList"
                                        :key="item.productTypeCode"
                                        :label="item.productTypeName"
                                        :value="item.productTypeCode">
                                </el-option>
                            </el-select>
                        </span>
                            <span>发货药房:
                                 <el-select
                                         size="small"
                                         v-model="OrderMaster.pharmacyId"
                                         placeholder="请选择药房" style="width: 170px" @change="queryByTypeCode()">
                                <el-option
                                        v-for="item in pharmacyList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </span>
                            <span v-if="pharmacy.typeCode==='YING_PIAN'">
                            <el-radio-group v-model="OrderMaster.slaves[0].needFry">

                             <el-radio-button label="1"
                                              v-if="pharmacy.isFry==0 ||pharmacy.isFry==1">代煎</el-radio-button>
                             <el-radio-button label="0" v-if="pharmacy.isFry==0 ">不代煎</el-radio-button>

                            </el-radio-group>
                                </span>
                            <span v-if="pharmacy.typeCode==='GAO_FANG'">
                               <el-select
                                       size="small" v-model="OrderMaster.slaves[0].packageManner"
                                       @change="getPackageManner"
                                       placeholder="请选择包装方式" style="width: 120px;margin-right: 10px">
                                <el-option
                                        v-for="item in packageMannerList"
                                        :key="item.packageMethod"
                                        :label="item.packageMethod"
                                        :value="item.packageMethod">
                                </el-option>
                            </el-select>
                                </span>
                            <span v-if="pharmacy.typeCode==='WAN_JI'">
                               <el-select
                                       size="small" v-model="OrderMaster.slaves[0].categoryCode" @change="getDosageType"
                                       placeholder="请选择包装方式" style="width: 120px;margin-right: 10px">
                                <el-option
                                        v-for="item in dosageTypeList"
                                        :key="item.dosageSubType"
                                        :label="item.typeName"
                                        :value="item.dosageSubType">
                                </el-option>
                            </el-select>
                                </span>
                        </div>
                        <el-form :model="OrderMaster.slaves[0]" :rules="rule" ref="diagnose3">
                            <div class="flex-box">
                                <el-form-item label="剂数:" class="flex-box" prop="count"
                                              v-if="OrderMaster.typeCode=='KE_LI'||OrderMaster.typeCode=='YING_PIAN'">
                                    <el-input-number style="width: 100px" size="small"
                                                     v-model.number="OrderMaster.slaves[0].count" :min="0"
                                                     @keydown="handleInput"
                                                     @change="computersPrice"
                                                     　></el-input-number>
                                </el-form-item>
                                <el-form-item label="服用天数:" class="flex-box" prop="takeDays"
                                              v-if="OrderMaster.typeCode!='KE_LI'&&OrderMaster.typeCode!='YING_PIAN'">
                                    <el-input-number style="width: 100px" size="small" :min="1"
                                                     @keydown="handleInput"
                                                     v-model.number="OrderMaster.slaves[0].takeDays"
                                                     　></el-input-number>
                                </el-form-item>
                                <el-form-item label="服用方法:" class="flex-box" style="margin-left: 40px"
                                              prop="orderUsage">
                                    <el-input style="width: 500px"
                                              v-model="OrderMaster.slaves[0].orderUsage"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                        <div class="flex-box" style="justify-content: space-between">
                        <span>药材检索:
                            <el-autocomplete
                                    clearable
                                    style="width: 270px;"
                                    suffix-icon="el-icon-search"
                                    size="small"
                                    class="inline-input"
                                    v-model="ingredients"
                                    :fetch-suggestions="querySearch"
                                    placeholder="请输入药材名称进行搜索"
                                    :trigger-on-focus="true"
                                    @select="medicinalSelect"
                            ></el-autocomplete>
                        </span>
                            <div class="flex-box">
                                <el-button type="text" @click="queryAdjust">附加费用</el-button>
                                <el-button type="text" @click="history">历史处方</el-button>
                                <el-button type="text" @click="queryAI">使用AI诊断</el-button>
                                <el-button type="text" @click="getPrescribe">使用处方大全</el-button>
                                <el-button type="text" @click="getMyPrescribe">使用自备良方</el-button>
                                <el-button type="text" @click="savePrescribe">保存自备良方</el-button>
                                <el-button type="text" @click="emptyIngredients">清空药材</el-button>
                            </div>
                        </div>
                        <el-table :data="OrderMaster.slaves[0].items"
                                  stripe
                                  :header-cell-style="{'padding-left': '2%'}"
                                  :cell-style="{'padding-left': '2%'}">
                            <el-table-column prop="name" label="药材名称">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.isNull" style="color: red">{{scope.row.name}}&nbsp(缺)</span>
                                    <span v-else>{{scope.row.name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价(元)">
                                <template slot-scope="scope">
                                    <span>{{scope.row.price}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="unitLabel">
                                <template slot-scope="scope">
                                    <el-form :model="scope.row" :rules="rule" ref="diagnose4">
                                        <el-form-item prop="count">
                                            <el-input-number style="width: 150px" size="small"
                                                             v-model.number="scope.row.count"
                                                             @keydown="handleInput" :min="0"
                                                             　></el-input-number>
                                        </el-form-item>
                                    </el-form>
                                    <!--<el-input style="width: 70px" size="small" v-model="scope.row.count"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>-->
                                </template>
                            </el-table-column>
                            <el-table-column prop="quantityUnit" label="单位">
                            </el-table-column>
                            <el-table-column label="煎服法备注">
                                <template slot-scope="scope">
                                    <el-select
                                            v-if="OrderMaster.typeCode === 'GAO_FANG' ||OrderMaster.typeCode === 'YING_PIAN'"
                                            size="small"
                                            v-model="scope.row.decoctionMethod" placeholder="请选择"
                                            style="width: 120px;">
                                        <el-option label="无" value="无"></el-option>
                                        <el-option label="先煎" value="先煎"></el-option>
                                        <el-option label="后下" value="后下"></el-option>
                                        <el-option label="包煎" value="包煎"></el-option>
                                        <el-option label="打碎" value="打碎"></el-option>
                                        <el-option label="另煎" value="另煎"></el-option>
                                        <el-option label="冲服" value="冲服"></el-option>
                                        <el-option label="打粉" value="打粉"></el-option>
                                        <el-option label="烊化" value="烊化"></el-option>
                                    </el-select>
                                    <span v-else>/</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-link type="danger" @click="deleteIngredients(scope.$index)">删除</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-if="medicineType==='2'">
                        <div class="flex-box" style="justify-content: space-between">
                        <span><!--药材检索:
                            <el-autocomplete
                                    clearable
                                    style="width: 270px;"
                                    suffix-icon="el-icon-search"
                                    size="small"
                                    class="inline-input"
                                    v-model="productQuery.productName"
                                    :fetch-suggestions="queryProduct"
                                    placeholder="请输入药材名称进行搜索"
                                    @select="productSelect"
                            ></el-autocomplete>-->
                            <el-button type="text" @click="openQueryProduct">查看所有药品</el-button>
                        </span>
                            <div>
                                <!--  <el-button type="text" @click="history">历史处方</el-button>-->
                                <el-button type="text" @click="emptyProducts">清空药材</el-button>
                            </div>

                        </div>

                        <el-table :data="OrderMaster.slaves1"
                                  stripe
                                  :header-cell-style="{'padding-left': '2%'}"
                                  :cell-style="{'padding-left': '2%'}">
                            <el-table-column label="图片" width="100px">
                                <template slot-scope="scope">
                                    <a target="_blank"
                                       :href="'http://www.zgtyyy.com/chinesemedicine'+scope.row.items[0].img">
                                        <img :src="'http://www.zgtyyy.com/chinesemedicine'+scope.row.items[0].img"
                                             width="100px" height="100px"></a>
                                </template>
                            </el-table-column>
                            <el-table-column label="药材名称">
                                <template slot-scope="scope">
                                    <span>{{scope.row.items[0].name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价">
                                <template slot-scope="scope">
                                    <span>{{scope.row.items[0].price/100}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="规格">
                                <template slot-scope="scope">
                                    <span>{{scope.row.items[0].specification}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="用药总量">
                                <template slot-scope="scope">
                                    <el-form :model="scope.row.items[0]" :rules="rule" ref="diagnose4">
                                        <el-form-item prop="count">
                                            <el-input-number style="width: 120px" size="small" :min="0"
                                                             v-model.number="scope.row.items[0].count"
                                                             　></el-input-number>
                                        </el-form-item>
                                    </el-form>
                                    <!--<el-input style="width: 70px" size="small" v-model="scope.row.count"  oninput="value=value.replace(/[^\d]/g,'')"></el-input>-->
                                </template>
                            </el-table-column>
                            <el-table-column prop="itemUsage" label="服用方法">
                                <template slot-scope="scope">
                                    <span>{{scope.row.items[0].itemUsage}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-link type="danger" @click="deleteProduct(scope.$index)">删除</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                </div>
            </div>
            </el-aside>
           
        </el-container>
        <el-drawer title="处方大全" :visible.sync="isUsePrescribeVisible" size="1200px">
            <div class="drawer">
                <el-scrollbar style=" height:900px;overflow: auto">
                    <div style="padding: 0 10px 0;">
                        <div class="top">
                            <div>
                                <el-select v-model="query.bookId" size="small" style="width: 158px" placeholder="请选择科目">
                                    <el-option v-for="item in bookList" :key="item.id" :label="item.bookName"
                                               :value="item.id"></el-option>
                                </el-select>
                                <el-input v-model="query.title" clearable
                                          placeholder="请输入处方名称或病症"
                                          suffix-icon="el-icon-search"
                                          style="width: 260px;margin-left: 20px"
                                          size="small">
                                </el-input>
                            </div>
                        </div>
                        <div>
                            <el-table :data="prescribeData">
                                <el-table-column prop="title" label="处方名称" width="150px"></el-table-column>
                                <el-table-column prop="bookName" label="科目" width="100px"></el-table-column>
                                <el-table-column prop="application" width="200px" label="主治"></el-table-column>
                                <el-table-column prop="usage1" width="500px" label="用法"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" style="margin-right: 10px"
                                                   @click="openPrescribeMessage(scope.row)">查看详情
                                        </el-button>
                                        <!--                                        <el-button type="text" style="margin-right: 10px"
                                                                                           @click="enterPrescribeList(scope.row)">录入
                                                                                </el-button>-->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    layout="total, prev, pager, next, jumper"
                                    :current-page="prescribeNum"
                                    :page-size="prescribeSize"
                                    :total="prescribeTotal"
                                    @current-change="handlePageChange"
                            ></el-pagination>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </el-drawer>
        <el-dialog title="查看详情" :visible.sync="prescribeALLVisible" width="520px">
            <el-table :data="prescribeMessage"
                      height="400px"
                      :header-cell-style="{'padding-left': '10%'}"
                      :cell-style="{'padding-left': '10%'}">
                <el-table-column prop="medicineName" label="药材名称"></el-table-column>
                <el-table-column label="剂量(克)">
                    <template slot-scope="scope">
                        <span v-if="scope.row.number === ''">/</span>
                        <span v-else>{{scope.row.number}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="prescribeALLVisible = false" style="width: 76px">取消</el-button>
                        <el-button type="primary" @click="enterPrescribe" style="width: 76px">录入</el-button>
                    </span>
        </el-dialog>
        <el-drawer title="自备良方" :visible.sync="myPrescribeVisible" size="860px">
            <div class="drawer">
                <el-scrollbar style="height:900px;overflow: auto">
                    <div style="padding: 20px 20px 0;">
                        <el-input size="small" style="width: 200px;margin-bottom: 15px" placeholder="请输入自备良方名称"
                                  clearable
                                  suffix-icon="el-icon-search" v-model="myPrescribeName"></el-input>
                        <el-table :data="myPrescribeList"
                                  :header-cell-style="{'padding-left': '2%'}"
                                  :cell-style="{'padding-left': '2%'}">
                            <el-table-column prop="prescriptionName" label="自备良方名称" width="150px"></el-table-column>
                            <el-table-column label="药材明细">
                                <template slot-scope="scope">
                                    <div style="display: flex;flex-direction: row;width: 650px;flex-wrap:wrap;">
                                        <div style="width: 94px!important;"
                                             v-for="item in  scope.row.doctorPrescriptionList">
                                            {{item.medicineName}}×{{item.count}}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100px">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="enterMyPrescribe(scope.row.doctorPrescriptionList)">
                                        录入
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    layout="total, prev, pager, next"
                                    :current-page="myPrescribeNum"
                                    :page-size="10"
                                    :total="myPrescribeTotal"
                                    @current-change="handleMyPrescribe"
                            ></el-pagination>
                        </div>
                    </div>
                </el-scrollbar>
            </div>

        </el-drawer>
        <el-dialog title="保存自备良方" :visible.sync="savePrescribeVisible" width="620px" :close-on-click-modal="false"
                   :before-close="cancelAddMyPrescribe">
            <el-form ref="addMyPrescribe" :rules="savePrescribeRule" :model="savePrescribeData" size="small">
                <el-form-item label="自备良方名称" prop="prescriptionName">
                    <el-input v-model="savePrescribeData.prescriptionName" style="width: 280px"></el-input>
                </el-form-item>
            </el-form>
            <div style="display: flex;flex-direction: row;width: 600px;flex-wrap:wrap;">
                药品：
                <div style="width: 94px!important;"
                     v-for="item in  savePrescribeData.doctorPrescriptionList">
                    {{item.medicineName}}×{{item.count}}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="cancelAddMyPrescribe" style="width: 76px">取消</el-button>
                        <el-button type="primary" @click="saveMyPrescribe" style="width: 76px">确定</el-button>
                    </span>
        </el-dialog>

        <el-dialog class="SD_dialog" title="处方详情" :visible.sync="detailVisible">
            <div class="recipe_box">
                <el-row style="border-bottom: 1px solid #EEEEEE;">
                    <el-col :span="6"><p>姓名：{{OrderMaster.patientName}}</p></el-col>
                    <el-col :span="6"><p>手机号：{{patient.phoneNumber}}</p></el-col>
                    <el-col :span="6" v-if="OrderMaster.patientSex === 1"><p>性别：男</p></el-col>
                    <el-col :span="6" v-else><p>性别：女</p></el-col>
                    <el-col :span="6"><p>年龄：{{OrderMaster.patientAge}}</p></el-col>
                </el-row>
                <el-row style="border-bottom: 1px solid #EEEEEE;">
                    <el-col :span="24"><p>诊断及症状：{{OrderMaster.doctorDiagnose}}</p></el-col>
                </el-row>
                <p>Rp</p>
                <el-row style="border-bottom: 1px solid #EEEEEE;">
                    <div v-for="item in OrderMaster.slaves[0].items">
                        <el-col :span="6"><p> {{item.name}}×{{item.count}}<span
                                v-if="OrderMaster.slaves[0].autograph!==''&&(item.isTaboo==1||item.isExcess==1)"
                                style="color: red">*{{OrderMaster.slaves[0].autograph}} </span></p></el-col>
                    </div>
                </el-row>
                <div>
                    <p>处方剂型：{{ OrderMaster.typeCode}}</p>
                    <p v-if="medicineType=='1'">剂数：{{OrderMaster.slaves[0].count}}剂</p>
                    <p>服用方法:{{OrderMaster.slaves[0].orderUsage}}</p>
                    <p>医嘱: {{OrderMaster.doctorAdvice}}</p>
                </div>
                <div style="min-width: 120px" v-if="OrderMaster.slaves[0].needFry==1">药品金额￥:
                    <span style="color: chocolate">{{(price-OrderMaster.slaves[0].priceOther*this.OrderMaster.slaves[0].count-this.OrderMaster.diagnoseAmt).toFixed(2)}}</span>
                </div>
                <div style="min-width: 120px" v-if="OrderMaster.slaves[0].needFry==0">药品金额￥:
                    <span style="color: chocolate">{{(price-this.OrderMaster.diagnoseAmt).toFixed(2)}}</span>
                </div>
                <div style="min-width: 120px"
                     v-if="OrderMaster.slaves[0].needFry==1||OrderMaster.slaves[0].typeCode=='GAO_FANG'||OrderMaster.slaves[0].typeCode=='WAN_JI'">
                    制作费￥:
                    <span style="color: chocolate">{{(OrderMaster.slaves[0].priceOther*this.OrderMaster.slaves[0].count).toFixed(2)}}</span>
                </div>
                <div style="min-width: 120px" v-else-if="OrderMaster.slaves[0].needFry==0">制作费￥:
                    <span style="color: chocolate">0</span>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="openWritePrescriptionType" style="width: 96px">确认开方</el-button>
            </div>
        </el-dialog>
        <!-- <el-dialog title="处方详情" :visible.sync="detailVisible" width="640px" :close-on-click-modal="false">
             <div style="margin-top: -20px;font-size: 14px">
                 <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                     <div style="min-width: 120px" v-if="OrderMaster.slaves[0].needFry==1">药品金额￥:
                         <span style="color: chocolate">{{(price-OrderMaster.slaves[0].priceOther*this.OrderMaster.slaves[0].count-this.OrderMaster.diagnoseAmt).toFixed(2)}}</span>
                     </div>
                     <div style="min-width: 120px" v-if="OrderMaster.slaves[0].needFry==0">药品金额￥:
                         <span style="color: chocolate">{{(price-this.OrderMaster.diagnoseAmt).toFixed(2)}}</span>
                     </div>
                     <div style="min-width: 120px"
                          v-if="OrderMaster.slaves[0].needFry==1||OrderMaster.slaves[0].typeCode=='GAO_FANG'||OrderMaster.slaves[0].typeCode=='WAN_JI'">
                         制作费￥:
                         <span style="color: chocolate">{{(OrderMaster.slaves[0].priceOther*this.OrderMaster.slaves[0].count).toFixed(2)}}</span>
                     </div>
                     <div style="min-width: 120px" v-else-if="OrderMaster.slaves[0].needFry==0">制作费￥:
                         <span style="color: chocolate">0</span>
                     </div>
                     <div style="min-width: 120px">患者资料:
                         <span>{{OrderMaster.patientName}}</span>
                     </div>
                     <div style="min-width: 40px;margin-left: 20px">
                         <span v-if="OrderMaster.patientSex === 1">男</span>
                         <span v-else-if="OrderMaster.patientSex === 2">女</span>
                     </div>
                     <div style="min-width: 40px;margin-left: 20px">{{OrderMaster.patientAge}}岁</div>
                     <div style="min-width: 40px;margin-left: 20px">{{patient.phoneNumber}}</div>
                 </div>
                 <div style="height: 20px;line-height: 20px;margin: 10px 0">
                     <span>诊断信息:{{OrderMaster.doctorDiagnose}}</span>
                 </div>
                 <div class="line" style="margin: 5px 0"></div>
                 <div style="height: 20px;line-height: 20px;margin: 10px 0">
                     <span>处方剂型:{{  OrderMaster.typeCode}}</span>
                 </div>
                 <div style="min-height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                     <span>处方明细:</span>
                     <div style="display: flex;flex-direction: row;flex-wrap:wrap;width: 410px;">
                         <div v-for="item in OrderMaster.slaves[0].items" style="width: 100px;">
                             {{item.name}}×{{item.count}}<span
                                 v-if="OrderMaster.slaves[0].autograph!==''&&(item.isTaboo==1||item.isExcess==1)"
                                 style="color: red">*{{OrderMaster.slaves[0].autograph}} </span>
                         </div>
                     </div>
                 </div>
                 <div style="height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                     <div style="min-width: 120px">服法用量:{{OrderMaster.slaves[0].orderUsage}}</div>
                 </div>
                 <div style="height: 20px;line-height: 20px;margin: 10px 0"
                      v-if="OrderMaster.slaves[0].items.decoctionMethod !== ''">
                     <span style="margin-left: 62px">{{OrderMaster.slaves[0].items.decoctionMethod}}</span>
                 </div>
                 <div class="line" style="margin: 5px 0"></div>
                 <div style="height: 20px;line-height: 20px;display: flex;flex-direction: row">
                     <div style="width: 60px">医嘱:</div>
                     <div>{{OrderMaster.doctorAdvice}}</div>
                 </div>
             </div>
             <div slot="footer" class="dialog-footer">
                 <el-button @click="detailVisible = false" style="width: 76px">取消</el-button>
                 <el-button type="primary" @click="openWritePrescriptionType" style="width: 96px">确认开方</el-button>
             </div>
         </el-dialog>-->
        <el-dialog title="以下药品存在配伍禁忌,或超剂量,请确认是否修改。" :visible.sync="pwjjVisible" width="640px"
                   :close-on-click-modal="false">
            <div style="display: flex;flex-direction: row;flex-wrap:wrap;width: 410px;">

                <div v-if="pwjj.length>0">
                     <span>
                    以下药品存在配伍禁忌 :
                     </span>
                    <br>
                    <span v-for="item in pwjj">
                    {{item.isTabooMedicinal}}
                        </span>
                </div>
            </div>
            <br>
            <div style="display: flex;flex-direction: row;flex-wrap:wrap;width: 410px;">

                <div v-if="cjl.length>0">
                          <span>
                    以下药品存在超剂量 :
                           </span>
                    <br>
                    <span v-for="item in cjl">
                    {{item.medicineName}}*({{item.recommendLimit}}最大值)&nbsp
                </span>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="pwjjVisible = false" style="width: 96px">修改剂量</el-button>
                <el-button type="primary" @click="signatureVisible = true" style="width: 96px">签字确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="签字确认" :visible.sync="signatureVisible" width="400px" :close-on-click-modal="false">
            <div>
                <el-form :model="OrderMaster.slaves[0]" :rules="signatureRule" ref="signature">
                    <el-form-item prop="autograph">
                        <el-input style="width: 200px" size="small" v-model.number="OrderMaster.slaves[0].autograph"
                                  　></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pwjjsignatureVisible = false,pwjjVisible = true" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="signatureOpen" style="width: 96px">确认</el-button>
            </div>
        </el-dialog>
        <el-drawer title="诊断列表" :visible.sync="queryAIVisible" size="900px">
            <div class="drawer">
                <el-scrollbar style="height:900px;overflow: auto">
                    <div style="padding: 20px 20px 0;">
                        <el-input size="small" style="width: 200px;margin-bottom: 15px" placeholder="请输入患者姓名"
                                  suffix-icon="el-icon-search" v-model="queryAIName" clearable></el-input>
                        <el-radio-group v-model="AIstate" size="small" @change="queryAI">
                            <el-radio-button label="0">
                                未诊断
                            </el-radio-button>
                            <el-radio-button label="1">
                                以就诊
                            </el-radio-button>
                        </el-radio-group>
                        <el-table :data="queryAIList"
                                  :header-cell-style="{'padding-left': '2%'}"
                                  :cell-style="{'padding-left': '2%'}">
                            <el-table-column prop="name" label="患者姓名"></el-table-column>
                            <el-table-column label="性别" width="100px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.sex =='f'"> 女</span>
                                    <span v-else> 男</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="idNumber" label="手机号码"></el-table-column>
                            <el-table-column label="生成时间">
                                <template slot-scope="scope">
                                    <span> {{ scope.row.createTime}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="openAI(scope.row)">
                                        查看详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    layout="total, prev, pager, next, jumper"
                                    :current-page="queryAINum"
                                    :page-size="10"
                                    :total="queryAITotal"
                                    @current-change="handleQueryAI"
                            ></el-pagination>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </el-drawer>
        <el-dialog title="诊断详情" :visible.sync="openAIVisible" width="520px" :close-on-click-modal="false">
            <div>
                <div style="min-width: 120px">患者：
                    {{smartInquiry.name}}
                </div>
                <div style="min-width: 120px">性别：
                    <span v-if="smartInquiry.sex === 'm'">男</span>
                    <span v-else-if="smartInquiry.sex === 'f'">女</span>
                </div>
                <div style="min-width: 120px">年龄：
                    <span>{{smartInquiry.age}}</span>
                </div>
                <div style="min-width: 120px">手机号码：
                    <span>{{smartInquiry.idNumber}}</span>
                </div>
                <div style="min-width: 120px">检测时间：
                    <span>{{smartInquiry.createTime}}</span>
                </div>
                <div style="min-width: 120px">主述：
                    <el-input v-model="smartInquiry.mainCom"></el-input>
                </div>
                <div style="min-width: 120px">主症：
                    <el-input v-model="smartInquiry.primSym"></el-input>
                </div>
                <div style="min-width: 120px">兼症：
                    <el-input v-model="smartInquiry.acpnSym"></el-input>
                </div>
                <div style="min-width: 120px">辩症：
                    <el-input v-model="smartInquiry.synResult"></el-input>
                </div>
                <div style="min-width: 120px">辩病：
                    <el-input v-model="smartInquiry.disResult"></el-input>
                </div>
            </div>

            <div style="min-height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                <span>建议方:</span>
                <div style="display: flex;flex-direction: row;flex-wrap:wrap;width: 410px;"
                     v-if="undefined!=bookDetail">
                    <div v-for="item in bookDetail.bookRecipeList">
                        {{item.medicineName}}×{{item.number}}&nbsp
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="updateAI" style="width: 76px">保存</el-button>
                        <el-button type="primary" @click="AISpeedinessVisible=true" style="width: 96px">快速开方</el-button>
                    </span>
        </el-dialog>
        <el-dialog title="是否引用处方" :visible.sync="AISpeedinessVisible" width="400px">
            <span slot="footer" class="dialog-footer">
                        <el-button @click="NotAISpeediness" style="width: 76px">不引用</el-button>
                        <el-button type="primary" @click="AISpeediness" style="width: 76px">引用</el-button>
                    </span>
        </el-dialog>
        <!-- 打印表格容器 -->
        <el-dialog title="打印样式" :visible.sync="printVisible" width="530px" :close-on-click-modal="false">
            <div id="printTable" style="width:500px;">
                <table
                        style="width:100%;text-align:center;border-collapse:collapse;font-family: 楷体;font-size:12px;font-weight: bolder;">
                    <tbody id="printContent">
                    <tr>
                        <td colspan="6" height="30"><h2>处方笺</h2></td>
                    </tr>
                    <tr>
                        <td height="30" style="text-align:left;" width="100px">
                            姓名：{{OrderMaster.patientName}}
                        </td>
                        <td height="30" v-if="OrderMaster.patientSex == '1'">
                            性别：男
                        </td>
                        <td height="30" v-else-if="OrderMaster.patientSex == '2'">
                            性别：女
                        </td>
                        <td height="30">
                            年龄：{{OrderMaster.patientAge}}
                        </td>

                    </tr>
                    <tr style="border-top:1px solid #111">
                        <td colspan="6" height="20"></td>
                    </tr>
                    <tr>
                        <td colspan="6" height="20" style="text-align:left;">
                            症状及诊断：{{OrderMaster.doctorDiagnose}}
                        </td>
                    </tr>
                    <tr style="border-top:1px solid #111">
                        <td colspan="6" height="20"></td>
                    </tr>
                    <tr>
                        <td colspan="6" height="20" style="text-align:left;">
                            开方时间：{{ time }}
                        </td>
                    </tr>
                    <tr style="border-top:1px solid #111">
                        <td colspan="6"></td>
                    </tr>
                    <tr>
                        <td height="30" style="text-align:left;"><H2>RP</H2></td>
                    </tr>
                    <tr style="text-align:left;">
                        <td colspan="2" height="200">
                           <span v-for="(item,i) in OrderMaster.slaves[0].items">
                               <span style=" font-size:14px">{{item.name}}<span><span
                                       style="background-color: rgb(204,204,204)">{{item.decoctionMethod}}</span>&nbsp{{item.count}}{{item.quantityUnit}}</span>&nbsp<span
                                       v-if="(i+1)%3==0 &&i>=2"><br></span></span>
                            </span>
                        </td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30">剂数:{{OrderMaster.slaves[0].count}}剂</td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30" width="400px">服用方法:{{OrderMaster.slaves[0].orderUsage}}</td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30">医嘱: {{OrderMaster.doctorAdvice}}</td>
                    </tr>
                    <tr style="border-top:1px solid #111;text-align:left">
                        <td height="30" width="100px">医师:</td>
                        <td></td>
                        <td height="30" colspan="10" width="200px">药品金额:</td>
                    </tr>
                    <tr style="text-align:left">
                        <td height="30" width="100px">审核:</td>
                        <td width="200px">调配:</td>
                        <td width="200px">核对/发药:</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="printVisible=false" style="width: 76px">取消</el-button>
                <el-button type="primary" v-print="'#printTable'" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-drawer title="历史处方" :visible.sync="historyPrescriptionVisible" size="900px">
            <div class="drawer">
                <el-scrollbar style="height:900px;overflow: auto">
                    <div style="padding: 20px 20px 0;">
                        <el-input size="small" style="width: 200px;margin-bottom: 15px" placeholder="请输入患者姓名" clearable
                                  suffix-icon="el-icon-search" v-model="queryHistoryName"
                                  @change="history()"></el-input>
                        <el-input size="small" style="width: 200px;margin-bottom: 15px" placeholder="请输入诊断" clearable
                                  suffix-icon="el-icon-search" v-model="doctorDiagnose"
                                  @change="history()"></el-input>
                        <el-button @click="history()" style="width: 76px">搜索</el-button>
                        <el-radio-group v-model="HistoryStatus" size="small" @change="history()">
                            <el-radio-button label="0">
                                未购药
                            </el-radio-button>
                            <el-radio-button label="1">
                                已购药
                            </el-radio-button>
                        </el-radio-group>
                        <el-table :data="historyPrescriptionList"
                                  :header-cell-style="{'padding-left': '2%'}"
                                  :cell-style="{'padding-left': '2%'}">
                            <el-table-column prop="patientName" label="患者姓名"></el-table-column>
                            <el-table-column prop="doctorDiagnose" label="诊断"></el-table-column>
                            <el-table-column label="生成时间" width="200px">
                                <template slot-scope="scope">
                                    <span> {{ scope.row.createTime}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="priceTotal" label="金额"></el-table-column>
                            <el-table-column label="处方类型" width="150px">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.typeCode == 'KE_LI'">颗粒</span>
                                    <span v-else-if="scope.row.typeCode == 'YING_PIAN'">饮片</span>
                                    <span v-else-if="scope.row.typeCode == 'GAO_FANG'">膏方</span>
                                    <span v-else-if="scope.row.typeCode == 'WAN_JI'">丸剂</span>
                                    <span v-else>中成药西药</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="状态">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.status == '0'">待付款</span>
                                    <span v-else-if="scope.row.status == '1'&&scope.row.isAudiding==0">待审核</span>
                                    <span v-else-if="scope.row.status == '1'&&scope.row.isAudiding==2">审核不通过</span>
                                    <span v-else-if="scope.row.status == '1'&&scope.row.isAudiding==1">待发货</span>
                                    <span v-else-if="scope.row.status == '2'">待收货</span>
                                    <span v-else-if="scope.row.status == '3'">已完成</span>
                                    <span v-else-if="scope.row.status == '4'">售后中</span>
                                    <span v-else-if="scope.row.status == '5'">以退款</span>
                                    <span v-else-if="scope.row.status == '9'">已作废</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="openHistoryPrescription(scope.row)">
                                        查看详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    layout="total, prev, pager, next, jumper"
                                    :current-page="queryHistoryNum"
                                    :page-size="10"
                                    :total="queryHistoryTotal"
                                    @current-change="HistoryQueryAI"
                            ></el-pagination>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </el-drawer>
        <el-dialog title="历史处方详情" :visible.sync="openHistoryPrescriptionVisible" width="560px"
                   :close-on-click-modal="false">
            <div>
                <div>
                    <div style="min-width: 120px">患者：
                        {{HistoryPrescription.patientName}}
                    </div>
                    <div style="min-width: 120px">性别：
                        <span v-if="HistoryPrescription.patientSex === 1">男</span>
                        <span v-else-if="HistoryPrescription.patientSex === 2">女</span>
                    </div>
                    <div style="min-width: 120px">年龄：
                        <span>{{HistoryPrescription.patientAge}}</span>
                    </div>
                    <div style="min-width: 120px">患者主述：
                        <el-input v-model="HistoryPrescription.patientComplaint" :disabled="true"></el-input>
                    </div>
                    <div style="min-width: 120px">诊断信息：
                        <el-input v-model="HistoryPrescription.doctorDiagnose" :disabled="true"></el-input>
                    </div>
                    <div style="min-width: 120px">医嘱：
                        <el-input v-model="HistoryPrescription.doctorAdvice" :disabled="true"></el-input>
                    </div>
                    <div style="min-width: 120px">药房： {{HistoryPrescription.pharmacyName}}
                    </div>
                    <div style="min-width: 120px">药品类型： {{HistoryPrescription.typeCode}}
                    </div>
                </div>

                <div style="min-height: 20px;line-height: 20px;margin: 10px 0;display: flex;flex-direction: row">
                    <span>处方明细:</span>
                    <div style="display: flex;flex-direction: row;flex-wrap:wrap;width: 410px;">
                        <div v-for="item in HistoryPrescription.items" style="width: 100px;">
                            {{item.name}}×{{item.count}}&nbsp
                        </div>
                    </div>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="openHistoryPrescriptionVisible=false" style="width: 76px">取消</el-button>
                        <el-button type="primary" @click="openHistory(HistoryPrescription)"
                                   style="width: 96px">引用</el-button>
                    </span>
        </el-dialog>
        <el-drawer title="所有药品" :visible.sync="productVisible" size="1200px">
            <div class="drawer">
                <el-scrollbar style="height:1000px;overflow: auto">
                    <div style="padding: 20px 20px 0;">
                        <el-input size="small" style="width: 200px;margin-bottom: 15px" placeholder="请输入药品名称"
                                  suffix-icon="el-icon-search" v-model="productQuery.productName"
                                  @change="queryProduct"></el-input>
                        <span>
                            <el-select
                                    size="small" v-model="productQuery.productType"
                                    placeholder="请选择类型" style="width: 120px;margin-right: 10px"
                                    @change="getProductCategory">
                                <el-option
                                        v-for="item in typeCodeList"
                                        :key="item.productTypeCode"
                                        :label="item.productTypeName"
                                        :value="item.productTypeCode">
                                </el-option>
                            </el-select>
                        </span>
                        <span>
                                 <el-select
                                         size="small"
                                         v-model="productQuery.productSubType"
                                         placeholder="产品分类" style="width: 170px" @change="queryProduct()">
                                <el-option
                                        v-for="item in  subTypeCodeList"
                                        :key="item.typeCode"
                                        :label="item.typeName"
                                        :value="item.typeCode"
                                >
                                </el-option>
                            </el-select>
                        </span>
                        <table>
                            <tr>
                                <td>
                                    <el-table :data="productList"
                                              width="1000px"
                                    >
                                        <el-table-column label="图片" width="100px">
                                            <template slot-scope="scope">
                                                <a target="_blank"
                                                   :href="'http://www.zgtyyy.com/chinesemedicine'+scope.row.mainPic"><img
                                                        :src="'http://www.zgtyyy.com/chinesemedicine'+scope.row.mainPic"
                                                        width="100px" height="100px"></a>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="药品名称">
                                            <template slot-scope="scope">
                                                <span> {{ scope.row.productName}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="规格">
                                            <template slot-scope="scope">
                                                <span> {{ scope.row.specification}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="单价" width="100px">
                                            <template slot-scope="scope">
                                                <span> {{ scope.row.price/100}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="200px">
                                            <template slot-scope="scope">
                                                <!--                         <el-button type="text" @click="openProductDetail(scope.row)">
                                                                             查看详情
                                                                         </el-button>-->
                                                <el-button type="text" @click="productSelect(scope.row)">
                                                    添加
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="pagination">
                                        <el-pagination
                                                background
                                                layout="total, prev, pager, next, jumper"
                                                :current-page="productNum"
                                                :page-size="10"
                                                :total="productTotal"
                                                @current-change="productQueryPage"
                                        ></el-pagination>
                                    </div>
                                </td>
                                <td style="position:fixed">
                                    <el-table :data="OrderMaster.slaves1" width="800px" height="800px">
                                        <el-table-column label="图片" width="100px">
                                            <template slot-scope="scope">
                                                <a target="_blank"
                                                   :href="'http://www.zgtyyy.com/chinesemedicine'+scope.row.items[0].img">
                                                    <img :src="'http://www.zgtyyy.com/chinesemedicine'+scope.row.items[0].img"
                                                         width="100px" height="100px"></a>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="药品名称" width="100px">

                                            <template slot-scope="scope">
                                                <span v-if="scope.row.items[0]!=null"> {{ scope.row.items[0].name}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="数量" width="120px">
                                            <template slot-scope="scope">
                                                <el-input-number width="120px" size="small" :min="0"
                                                                 v-model="scope.row.items[0].count"
                                                                 v-if="scope.row.items[0]!=null"
                                                ></el-input-number>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="药品单价" width="100px">
                                            <template slot-scope="scope">
                                                <span style="color: darkorange"> {{ scope.row.items[0].price/100}} ￥</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="100px">
                                            <template slot-scope="scope">
                                                <el-button type="text" @click="deleteProduct(scope.$index)">
                                                    删除
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--  <div class="pagination">
                                          <el-pagination
                                                  background
                                                  layout="total, prev, pager, next, jumper"
                                                  :current-page="tableProductNum"
                                                  :page-size="10"
                                                  :total="tableProductTotal"
                                                  @current-change="tableProductQueryPage"
                                          ></el-pagination>
                                      </div>-->
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-scrollbar>
            </div>
        </el-drawer>
        <el-dialog title="产品确认开方" :visible.sync="productExtractionVisible" width="500px">
            <div class="dialog-foot-bottom">
                <el-button @click="productExtractionVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="writePrescription" style="width: 76px">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="附加费用" :visible.sync="adjustVisible" width="520px">
            <el-select
                    size="small" v-model="OrderMaster.adjustDesc1"
                    placeholder="请选择医师服务费" style="width: 120px;margin-right: 10px">
                <el-option
                        v-for="item in adjustList"
                        :key="item.adjustDesc"
                        :label="item.adjustDesc"
                        :value="item.adjustDesc">
                </el-option>
            </el-select>

            诊金：
            <el-input onkeyup="this.value=this.value.replace(/[^0-9.]/g,'')" size="small" style="width: 100px; "
                      :min="0"
                      v-model="OrderMaster.diagnoseAmt1" @keydown="handleInput"></el-input>
            <span slot="footer" class="dialog-footer">
                        <el-button @click="adjustVisible = false" style="width: 76px">取消</el-button>
                        <el-button type="primary" @click="getAdjust" style="width: 76px">确认</el-button>
                    </span>
        </el-dialog>
        <el-dialog title="请选择付款方式" :visible.sync="writePrescriptionTypeVisible" width="500px">
            <div class="dialog-foot-bottom">
                <el-button @click="writePrescription" style="width: 96px">线上付款</el-button>
                <el-button type="primary" @click="writePrescriptionV2" style="width: 106px">线下已付款</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    const isNum = (rule, value, callback) => {
        const age = /^[+]{0,1}(\d+)$/
        if (!age.test(value)) {
            callback(new Error('只能为数字'))
        } else {
            callback()
        }
    }
    export default {
        data() {
            return {
                sumPrice: 0,
                price: 0,
                DosageType: {},
                dosageTypeList: [],
                list: [],
                productVisible: false,
                tableProductNum: 0,
                tableProductTotal: 0,
                productNum: 1,
                productTotal: 0,
                productList: [],
                subTypeCodeList: [],
                typeCodeList: [],
                productQuery: {
                    productName: '',
                    productType: '',
                    productSubType: ''
                },
                HistoryStatus: 0,
                queryHistoryName: '',
                doctorDiagnose: '',
                HistoryPrescription: {
                    patientName: '',
                    patientAge: '',
                    patientSex: '',
                    patientComplaint: '',
                    doctorDiagnose: '',
                    doctorAdvice: ''
                },
                historyPrescriptionList: [],
                historyPrescriptionVisible: false,
                openHistoryPrescriptionVisible: false,
                queryHistoryNum: 1,
                queryHistoryTotal: 10,
                printVisible: false,
                userName: '',
                signatureVisible: false,
                OrderMaster: {
                    adjustDesc: '免费',
                    adjustDesc1: '免费',
                    adjustPercent: 0,
                    adjustType: '',
                    diagnoseAmt: 0,
                    diagnoseAmt1: 0,
                    diagnoseAmtType: "FREE",
                    doctorAdvice: '',
                    doctorDiagnose: '',
                    doctorId: '',
                    doctorMessage: "",
                    hiddenContent: "HIDDEN_NO",
                    hiddenDetail: 2,
                    isOnline: "",
                    orderType: 1,
                    patientAge: '',
                    patientComplaint: "",
                    patientId: '',
                    patientName: '',
                    patientPregnant: 2,
                    patientSex: 1,
                    pharmacyId: '',
                    //产品药品
                    slaves1: [],
                    //草药
                    slaves: [
                        {
                            orderUsage: "",
                            count: 1,
                            items: [],
                            needFry: 1,
                            pharmacyId: '',
                            priceOther: 0.0,
                            autograph: "",
                            packageManner: "",
                            takeDays: '',
                            takingState: '',
                            typeCode: ''
                        }
                    ],
                    status: 0,
                    typeCode: ''
                },
                cardUrl: localStorage.getItem('cardUrl'),
                administrativeOffice: localStorage.getItem('administrativeOffice'),
                rarelyUsed: 0,
                // token
                authorization: localStorage.getItem('authorization'),
                // 患者列表
                patientData: [],
                // 鼠标是否悬停在患者框上
                isHover: false,
                // 选中的患者框样式激活
                active: '',
                // 就诊记录
                patientId: '',
                recordPageNum: 1,
                recordPageSize: 13,
                seeVisible: false,
                seeDoctorData: [],
                patientRecord: {
                    caseHistory: '',
                    departmentName: '',
                    record: '',
                    prescription: '',
                    drugList: [],
                },
                activeRecord: '',
                // 显示的时间
                time: '',
                // 选中的患者信息
                patient: '',
                // 药房列表
                pharmacyList: [],
                // 选中的药房
                pharmacy: '',
                // 处方类型列表
                dosageList: [],
                // 搜索药材
                ingredients: '',
                // 药材列表剂量
                unitLabel: '剂量',
                // 开发数据
                // 开发数据

                rule: {
                    doctorDiagnose: [{required: true, message: '请输入临床诊断', trigger: 'blur'}],
                    doctorAdvice: [{required: true, message: '请输入医嘱', trigger: 'blur'}],
                    patientComplaint: [{required: true, message: '请输入患者主述', trigger: 'blur'}],
                    takeDays: [{required: true, message: '请输入服用天数', trigger: 'blur'}, {
                        type: 'number',
                        message: '请输入数字',
                        trigger: 'blur'
                    }],
                    orderUsage: [{required: true, message: '请输入服用方法', trigger: 'blur'}],
                    patientName: [{required: true, message: '请输入患者姓名', trigger: 'blur'}],
                    patientSex: [{required: true, message: '请输入患者性别', trigger: 'blur'}],
                    patientAge: [{required: true, message: '请输入患者年龄', trigger: 'blur'}, {
                        type: 'number',
                        message: '请输入数字',
                        trigger: 'blur'
                    }],
                    count: [{required: true, message: '请输入药品数量', trigger: 'blur'}, {
                        type: 'number',
                        message: '请输入数字',
                        trigger: 'blur'
                    },
                        {validator: isNum, trigger: 'blur'}],
                }, signatureRule: {
                    autograph: [{required: true, message: '请签字确认', trigger: 'blur'}]
                }, savePrescribeRule: {
                    prescriptionName: [{required: true, message: '处方名称不能为空', trigger: 'blur'}]
                },
                // 处方大全
                isUsePrescribeVisible: false,
                // 搜索
                query: {
                    title: '',
                    bookId: '',
                },
                // 科目列表
                bookList: [],
                // 处方大全列表
                prescribeData: [],
                // 处方大全列表分页
                prescribeNum: 1,
                prescribeSize: 10,
                prescribeTotal: 0,
                // 处方大全详情
                prescribeALLVisible: false,
                prescribeMessage: [],
                // 自备良方
                myPrescribeVisible: false,
                myPrescribeList: [],
                myPrescribeName: '',
                myPrescribeNum: 1,
                myPrescribeTotal: 0,
                queryAINum: '1',
                queryAIList: [],
                queryAIVisible: false,
                openAIVisible: false,
                queryAIName: '',
                AIstate: 0,
                queryAITotal: 0,
                smartInquiry: {},
                bookDetail: {},
                AISpeedinessVisible: false,
                // 保存自备良方
                savePrescribeVisible: false,
                myPrescribeAdd: {
                    prescriptionName: '',
                },
                // 完成就诊
                detailVisible: false,
                medicineType: '1',
                ProductType: ''
                ,
                SlavePriceNew: {
                    count: 1,
                    doctorId: '',
                    items: [],
                    needFry: 0,
                    pharmacyId: 0,
                    priceOther: 0,
                    typeCode: ""
                },
                isSub: {},
                prescriptionCost: 0,
                pwjj: [],
                cjl: [],
                pwjjVisible: false,
                ispwjj: false,
                savePrescribeData: {
                    medicinalMaterialsType: 0,
                    prescriptionName: '',
                    doctorPrescriptionList: []
                },
                packageMannerList: [],
                packageManner: {},
                adjustList: [],
                adjust: {},
                adjustVisible: false,
                productExtractionVisible: false,
                inviteVisible: false,
                writePrescriptionTypeVisible: false,
                isOnline: localStorage.getItem('isOnline'),
            }
        },
        created() {
            this.getData()
        },
        methods: {
            openWritePrescriptionType() {
                if (this.isOnline == '1') {
                    this.writePrescriptionTypeVisible = true
                } else {
                    this.writePrescription()

                }
            },
            changeDiagnoseAmt() {
                if (this.OrderMaster.diagnoseAmt > 0) {
                    this.OrderMaster.diagnoseAmtType = 'MANUAL'
                }
            },
            //获取产品科室
            getProductCategory() {
                let params = new FormData()
                params.append("productTypeCode", this.productQuery.productType);
                params.append("page", 0);
                params.append("limit", 100);
                this.axios.post('api-b/10005/getProductCategory', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code == 10000) {
                        this.subTypeCodeList = res.data.data.records
                        this.productQuery.productSubType = this.subTypeCodeList[0].typeCode
                        this.queryProduct()
                    }
                })
            },
            //获取产品类型
            getProductType() {
                let params = new FormData()
                params.append("state", 2);
                this.axios.post('api-b/10005/v1/getProductType', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code == 10000) {
                        this.typeCodeList = res.data.data

                    }
                })
            },
            computersPrice() {

            },
            getAdjust(val) {
                this.adjustVisible = false
                if (this.OrderMaster.diagnoseAmt > 0) {
                    this.OrderMaster.diagnoseAmtType = 'MANUAL'
                }
                this.OrderMaster.diagnoseAmt = this.OrderMaster.diagnoseAmt1
                this.adjust = this.adjustList.find(item => {
                    return this.OrderMaster.adjustDesc1 === item.adjustDesc
                })
                this.OrderMaster.adjustDesc = this.OrderMaster.adjustDesc1;
                this.OrderMaster.adjustType = this.adjust.type
                this.OrderMaster.adjustPercent = this.adjust.percent
                this.getPrice()
            },
            //查询医师服务费
            queryAdjust() {
                if (this.OrderMaster.pharmacyId == null || this.OrderMaster.pharmacyId == '') {
                    this.$message.info("请先选择患者")
                } else {
                    this.axios.get('api-b/10005/queryRuleByOrder?pharmacyId=' + this.OrderMaster.pharmacyId + '&medicinePrice=' + this.sumPrice, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.adjustList = res.data.data
                            this.adjustVisible = true
                        } else {
                            // this.$message.error(res.data.message)
                            this.adjustVisible = true
                        }
                    })
                }
            },
            //选择包装方式丸剂
            getDosageType(val) {
                this.DosageType = this.dosageTypeList.find(item => {
                    return this.OrderMaster.slaves[0].categoryCode === item.dosageSubType
                })
                this.OrderMaster.slaves[0].orderUsage = this.DosageType.itemUsage
                this.pharmacy.minMake = this.DosageType.minMake

            },
            //选择包装方式膏方
            getPackageManner(val) {
                this.packageManner = this.packageMannerList.find(item => {
                    return this.OrderMaster.slaves[0].packageManner === item.packageMethod
                })
                this.OrderMaster.slaves[0].takingState = this.packageManner.takingState;
            },
            //产品分页
            productQueryPage(val) {
                this.productNum = val;
                this.queryProduct();
            },
            tableProductQueryPage(val) {
                this.tableProductNum = val;
            },
            openProductDetail() {

            },
            //清空产品
            emptyProducts() {
                this.OrderMaster.slaves1 = []
            },
            //删除产品
            deleteProduct(index) {
                this.OrderMaster.slaves1.splice(index, 1)
                this.tableProductTotal = this.OrderMaster.slaves1.length / 10
                if (this.OrderMaster.slaves1.length % 10 != 0) {
                    this.tableProductTotal = this.tableProductTotal + 1
                }
            },
            //打开查询产品
            openQueryProduct() {
                this.getProductType()
                this.productVisible = true
                this.queryProduct()
            },
            //选择产品
            productSelect(val) {
                let id = true
                for (let i of this.OrderMaster.slaves1) {
                    if (i.items[0].itemId == val.productNo) {
                        id = false
                        this.$message.success("请勿重复添加")
                        return;
                    }
                }
                if (id) {
                    let slaves1 = {
                        categoryCode: val.productSubType,
                        count: 0,
                        items: [
                            {
                                name: val.productName,
                                count: 0,
                                itemId: val.productNo,
                                itemUsage: val.productUsage,
                                typeCode: val.productType,
                                img: val.mainPic,
                                price: val.price,
                                specification: val.specification
                            }
                        ],
                        needFry: 0,
                        orderUsage: "",
                        pharmacyId: val.pharmacyNo,
                        priceOther: 0,
                        typeCode: val.productType
                    }
                    this.OrderMaster.slaves1.unshift(slaves1)
                    this.tableProductTotal = Math.ceil(this.OrderMaster.slaves1.length)
                }
            },
            //查询产品
            queryProduct() {
                this.axios.post('api-s/10046/100210/' + this.productNum + '/10', this.productQuery, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.productList = res.data.data.list;
                        this.productTotal = res.data.data.total;

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            handleInput(e) {
                let a = e.key.replace(/^[+]{0,1}(\d+)$/, "");
                if (!a) {
                    e.preventDefault();
                }
            },
            //历史处方换页
            HistoryQueryAI(val) {
                this.queryHistoryNum = val
                this.history()
            },
            //引用处方
            openHistory(data) {
                let is = false;
                let params1 = new FormData();
                params1.append("state", "1")

                this.axios.post('api-b/10038/100187', params1, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {

                    if (res.data.code === 10000) {
                        this.dosageList = res.data.data
                        for (let i of this.dosageList) {
                            if (i.productTypeCode == data.typeCode) {
                                is = true;
                                break;
                            }
                        }
                        if (is) {
                            this.OrderMaster.doctorDiagnose = data.doctorDiagnose
                            this.OrderMaster.patientAge = data.patientAge
                            this.OrderMaster.patientSex = data.patientSex;
                            this.OrderMaster.slaves[0].count = data.count;
                            this.OrderMaster.patientName = data.patientName;
                            this.OrderMaster.patientComplaint = data.patientComplaint;
                            this.OrderMaster.patientId = data.patientId;
                            this.OrderMaster.doctorAdvice = data.doctorAdvice;
                            this.OrderMaster.typeCode = data.typeCode;
                            this.OrderMaster.pharmacyId = data.pharmacyId
                            this.OrderMaster.slaves[0].takeDays = data.takeDays
                            this.OrderMaster.slaves[0].needFry = data.needFry
                            let params = {
                                count: 1,
                                items: [],
                                needFry: this.OrderMaster.slaves[0].needFry,
                                pharmacyId: this.OrderMaster.pharmacyId,
                                typeCode: this.OrderMaster.typeCode
                            }
                            for (let i = 0; i < data.items.length; i++) {
                                let item = {
                                    medicineName: data.items[i].name,
                                    count: data.items[i].count,
                                    quantityUnit: data.items[i].quantityUnit,
                                }
                                params.items.push(item)
                            }
                            this.axios.get('api-b/10008/100186?typeCode=' + this.OrderMaster.typeCode, {
                                headers: {
                                    Authorization: this.authorization
                                }
                            }).then(res => {

                                if (res.data.code === 10000) {
                                    this.pharmacyList = res.data.data
                                    this.queryByTypeCode1()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                            this.querySlavePriceNew(params)
                            this.openHistoryPrescriptionVisible = false;
                            this.historyPrescriptionVisible = false;

                        } else {
                            this.$message.info("当前方式仅支持中草药")
                            this.openHistoryPrescriptionVisible = false;
                            this.historyPrescriptionVisible = false;
                        }
                    }
                })


            },
            //打开处方详情
            openHistoryPrescription(data) {
                this.HistoryPrescription = data
                this.openHistoryPrescriptionVisible = true;
            },
            //查询历史处方
            history() {
                this.axios.get('api-b/10005/hisOrder?status=' + this.HistoryStatus + '&name=' + this.queryHistoryName + '&page=' + this.queryHistoryNum
                    + '&doctorDiagnose=' + this.doctorDiagnose, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.records.length > 0) {
                            this.historyPrescriptionList = res.data.data.records;
                            this.queryHistoryNum = res.data.data.current;
                            this.queryHistoryTotal = res.data.data.total;
                            this.historyPrescriptionVisible = true;
                            for (let i of this.historyPrescriptionList) {
                                i.createTime = new Date(+new Date(i.createTime) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
                            }
                        }else {
                            this.historyPrescriptionList=[]
                            this.queryHistoryNum = res.data.data.current;
                            this.queryHistoryTotal = res.data.data.total;
                            this.historyPrescriptionVisible = true;
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },
            //保存自备良方
            savePrescribe() {
                this.savePrescribeData = {
                    medicinalMaterialsType: 0,
                    prescriptionName: '',
                    doctorPrescriptionList: []
                }
                let items = this.OrderMaster.slaves[0].items;

                if (items.length > 0) {
                    for (let i of items) {
                        let item = {
                            medicineName: '',
                            count: ''
                        }
                        if (i.count == null || i.count == 0) {
                            this.savePrescribeData = {
                                medicinalMaterialsType: 0,
                                prescriptionName: '',
                                doctorPrescriptionList: []
                            }
                            break
                        }
                        item.medicineName = i.name
                        item.count = i.count
                        this.savePrescribeData.doctorPrescriptionList.push(item)
                    }
                    if (this.savePrescribeData.doctorPrescriptionList.length > 0) {
                        this.savePrescribeVisible = true
                    } else {
                        this.$message.info("药品数量")
                    }
                } else {
                    this.$message.info("请先选择药品")
                }


            },
            //医生签名
            signatureOpen() {
                this.$refs.signature.validate(valid => {
                    if (valid) {
                        this.signatureVisible = false;
                        this.pwjjVisible = false;
                        this.detailVisible = true;
                        this.ispwjj = true;
                    }
                })

            },

            /**
             * 查询剂型服用方法
             * @param val
             */
            queryByTypeCode(val) {
                this.list = []
                this.ingredients = ''
                this.pharmacy = this.pharmacyList.find(item => {
                    return this.OrderMaster.pharmacyId === item.id
                })
                if (this.OrderMaster.typeCode == 'YING_PIAN') {
                    this.OrderMaster.slaves[0].priceOther = this.pharmacy.priceFry
                }
                if (this.OrderMaster.typeCode == 'GAO_FANG') {
                    this.axios.get('api-b/10005/query?pharmacyId=' + this.OrderMaster.pharmacyId + '&typeCode=' + this.OrderMaster.typeCode, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.packageMannerList = res.data.data
                            this.OrderMaster.slaves[0].packageManner = this.packageMannerList[0].packageMethod
                            this.OrderMaster.slaves[0].orderUsage = this.packageMannerList[0].itemUsage
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
                if (this.OrderMaster.typeCode == 'WAN_JI') {
                    this.axios.get('api-b/10005/queryByPharmacy?pharmacyId=' + this.OrderMaster.pharmacyId + '&typeCode=' + this.OrderMaster.typeCode, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.dosageTypeList = res.data.data
                            this.OrderMaster.slaves[0].orderUsage = this.dosageTypeList.itemUsage
                            this.pharmacy.minMake = this.dosageTypeList[0].minMake
                            this.OrderMaster.slaves[0].categoryCode = this.dosageTypeList[0].typeName
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }


                this.OrderMaster.slaves[0].needFry = this.pharmacy.isFry
                this.axios.get('api-b/10005/queryByTypeCode?pharmacyId=' + this.OrderMaster.pharmacyId + '&typeCode=' + this.OrderMaster.typeCode, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.inside.length > 0) {
                            this.OrderMaster.slaves[0].orderUsage = res.data.data.inside[0].itemUsage
                            this.OrderMaster.slaves[0].takingState = res.data.data.inside[0].takingState
                            if (this.OrderMaster.slaves[0].items.length > 0) {
                                let params = {
                                    count: 1,
                                    items: [],
                                    needFry: this.OrderMaster.slaves[0].needFry,
                                    pharmacyId: this.OrderMaster.pharmacyId,
                                    typeCode: this.OrderMaster.typeCode
                                }
                                for (let i = 0; i < this.OrderMaster.slaves[0].items.length; i++) {
                                    let item = {
                                        medicineName: this.OrderMaster.slaves[0].items[i].name,
                                        count: this.OrderMaster.slaves[0].items[i].count,
                                        quantityUnit: this.OrderMaster.slaves[0].items[i].quantityUnit,
                                    }
                                    params.items.push(item)
                                }
                                this.querySlavePriceNew(params)
                            }
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            /**
             *历史处方快速开方 查询剂型服用方法
             * @param val
             */
            queryByTypeCode1(val) {

                this.pharmacy = this.pharmacyList.find(item => {
                    return this.OrderMaster.pharmacyId === item.id
                })
                if (this.OrderMaster.typeCode == 'YING_PIAN') {
                    this.OrderMaster.slaves[0].priceOther = this.pharmacy.priceFry
                }
                if (this.OrderMaster.typeCode == 'GAO_FANG') {
                    this.axios.get('api-b/10005/query?pharmacyId=' + this.OrderMaster.pharmacyId + '&typeCode=' + this.OrderMaster.typeCode, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.packageMannerList = res.data.data
                            this.OrderMaster.slaves[0].packageManner = this.packageMannerList[0].packageMethod
                            this.OrderMaster.slaves[0].orderUsage = this.packageMannerList[0].itemUsage
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
                if (this.OrderMaster.typeCode == 'WAN_JI') {
                    this.axios.get('api-b/10005/queryByPharmacy?pharmacyId=' + this.OrderMaster.pharmacyId + '&typeCode=' + this.OrderMaster.typeCode, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.dosageTypeList = res.data.data
                            this.OrderMaster.slaves[0].orderUsage = this.dosageTypeList.itemUsage
                            this.pharmacy.minMake = this.dosageTypeList[0].minMake
                            this.OrderMaster.slaves[0].categoryCode = this.dosageTypeList[0].typeName
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }


                this.OrderMaster.slaves[0].needFry = this.pharmacy.isFry
                this.axios.get('api-b/10005/queryByTypeCode?pharmacyId=' + this.OrderMaster.pharmacyId + '&typeCode=' + this.OrderMaster.typeCode, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.inside.length > 0) {
                            this.OrderMaster.slaves[0].orderUsage = res.data.data.inside[0].itemUsage
                            this.OrderMaster.slaves[0].takingState = res.data.data.inside[0].takingState
                            if (this.OrderMaster.slaves[0].items.length > 0) {
                                let params = {
                                    count: 1,
                                    items: [],
                                    needFry: this.OrderMaster.slaves[0].needFry,
                                    pharmacyId: this.OrderMaster.pharmacyId,
                                    typeCode: this.OrderMaster.typeCode
                                }
                                for (let i = 0; i < this.OrderMaster.slaves[0].items.length; i++) {
                                    let item = {
                                        medicineName: this.OrderMaster.slaves[0].items[i].name,
                                        count: this.OrderMaster.slaves[0].items[i].count,
                                        quantityUnit: this.OrderMaster.slaves[0].items[i].quantityUnit,
                                    }
                                    params.items.push(item)
                                }
                                this.querySlavePriceNew(params)
                            }
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取药房列表
            getPharmacy(val) {

                this.ProductType = this.dosageList.find(item => {
                    return item.productTypeCode === val
                })
                this.axios.get('api-b/10008/100186?typeCode=' + val, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.pharmacyList = res.data.data
                        this.OrderMaster.pharmacyId = this.pharmacyList[0].id;
                        this.OrderMaster.slaves[0].pharmacyId = '';
                        this.queryByTypeCode()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取剂型列表
            selectPharmacy() {
                let params = new FormData();
                params.append("state", "1")
                this.axios.post('api-b/10038/100187', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res)
                    if (res.data.code === 10000) {
                        this.dosageList = res.data.data
                        if (this.dosageList.length > 0) {
                            if (this.OrderMaster.typeCode == '') {
                                this.OrderMaster.typeCode = this.dosageList[0].productTypeCode;
                            }
                            this.axios.get('api-b/10008/100186?typeCode=' + this.OrderMaster.typeCode, {
                                headers: {
                                    Authorization: this.authorization
                                }
                            }).then(res => {

                                if (res.data.code === 10000) {
                                    this.pharmacyList = res.data.data
                                    if (this.pharmacyList.length > 0) {
                                        if (this.OrderMaster.pharmacyId > 0) {

                                        } else {
                                            this.OrderMaster.pharmacyId = this.pharmacyList[0].id;
                                            this.OrderMaster.slaves[0].pharmacyId = this.pharmacyList[0].id;
                                        }
                                        this.queryByTypeCode()
                                    }
                                    /*                                    if(this.OrderMaster.slaves[0].items.length>0){
                                                                            let params = {
                                                                                count: 1,
                                                                                items: [],
                                                                                needFry: 0,
                                                                                pharmacyId: this.OrderMaster.pharmacyId,
                                                                                typeCode: this.OrderMaster.typeCode
                                                                            }
                                                                            for (let i = 0; i < this.OrderMaster.slaves[0].items.length; i++) {
                                                                                let item = {
                                                                                    medicineName: this.OrderMaster.slaves[0].items[i].name,
                                                                                    count: this.OrderMaster.slaves[0].items[i].count,
                                                                                    quantityUnit: this.OrderMaster.slaves[0].items[i].quantityUnit,
                                                                                }
                                                                                params.items.push(item)
                                                                            }
                                                                            this.querySlavePriceNew(params)
                                                                        }*/
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //查询医生医嘱详情
            queryDoctorAdvice() {
                this.axios.get('api-b/10005/queryDoctorAdvice', {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {

                    if (res.data.code === 10000) {
                        if (res.data.data.length > 0) {
                            this.OrderMaster.doctorAdvice = res.data.data[0].advice
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取侧边患者列表
            getData() {
                this.axios.get('/api-b/10026/100011?patientName=' + this.userName + "&rarelyUsed=" + this.rarelyUsed, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then((res) => {
                    if (res.status === 200) {
                        if (res.data.code === 10000) {
                            if (res.data.data.length !== 0) {
                                let data = res.data.data;
                                this.patientData = data;
                                // this.patient = this.patientData[0]
                                // this.active = this.patientData[0].patientId
                            } else {
                                this.$message.info('暂无患者');
                                this.patientData = []
                            }
                        } else {
                            this.$message.error(res.data.message)
                            this.patientData = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.patientData = []
                    }
                }).catch(error => {
                    this.patientData = []
                })
            },
            // 获取就诊记录
            getRecord() {
                this.axios.get('/api-b/10026/100063/' + this.recordPageNum + "/" + this.recordPageSize
                    + '?patientId=' + this.patientId, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    this.recordPageNum++
                    if (res.data.code === 10000) {
                        this.seeVisible = true
                        this.seeDoctorData.push(...res.data.data.list)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 查看就诊记录
            seeRecord(data) {
                this.patientId = data.patientId
                this.axios.get('/api-b/10026/100063/' + this.recordPageNum + "/" + this.recordPageSize
                    + '?patientId=' + this.patientId, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.recordPageNum++
                        this.seeVisible = true
                        this.recordTotal = res.data.data.total
                        this.seeDoctorData = res.data.data.list
                        this.activeRecord = this.seeDoctorData[0].caseHistoryId
                        this.getRecordData(this.seeDoctorData[0].caseHistoryId)
                    } else {
                        this.$message.info(res.data.message)
                    }
                })
            },
            // 就诊记录下拉获取下一页
            load() {
                if (this.recordPageNum <= parseInt(this.recordTotal / this.recordPageSize) + 1) {
                    this.getRecord()
                }
            },
            // 关闭就诊记录
            closeSee() {
                this.seeVisible = false
                this.recordPageNum = 1
            },
            // 获取就诊记录详细信息
            getRecordData(data) {
                this.axios.get('/api-b/10009/100064?CaseHistoryId=' + data, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.patientRecord.caseHistory = res.data.data.caseHistory
                        this.patientRecord.departmentName = res.data.data.departmentName
                        this.patientRecord.record = res.data.data.patient
                        this.patientRecord.drugList = res.data.data.drugList
                        this.patientRecord.prescription = res.data.data.prescription
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 选择记录
            selectPatientRecord(data) {
                this.activeRecord = data.caseHistoryId
                this.getRecordData(data.caseHistoryId)
            },
            // 选择患者
            selectPatient(data) {

                this.axios.get('api-b/10005/checkSubscribe?userId=' + data.id, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.message !== '该患者已关注') {
                            this.$message.info("患者已取消关注")
                        } else {
                            this.active = data.id;
                            this.patient = data;
                            this.OrderMaster.patientId = data.id;
                            this.OrderMaster.patientName = data.realName;
                            this.OrderMaster.patientSex = data.sex;
                            if (data.sex != 1 && data.sex != 2) {
                                this.OrderMaster.patientSex = 1;
                            }

                            this.OrderMaster.patientAge = Number(data.age);
                            this.queryDoctorAdvice()
                            this.selectPharmacy()
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },
            // 获取当前时间
            getTime() {
                const date = new Date()
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                m = m < 10 ? '0' + m : m;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let hh = date.getHours(); //时
                hh = hh < 10 ? ('0' + hh) : hh;
                let mm = date.getMinutes(); //分
                mm = mm < 10 ? ('0' + mm) : mm;
                let ss = date.getSeconds(); //秒
                ss = ss < 10 ? ('0' + ss) : ss;
                this.time = y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss
            },
            //计算价格
            getPrice() {
                let sum = 0
                if (this.medicineType == 1) {
                    if (this.OrderMaster.slaves[0].items.length > 0) {
                        for (let i of this.OrderMaster.slaves) {
                            for (let it of i.items) {
                                sum = sum + it.count * it.price
                            }
                        }
                    }
                    if (sum > 0) {
                        this.price = (sum * this.OrderMaster.slaves[0].count).toFixed(2)
                        this.sumPrice = (sum * this.OrderMaster.slaves[0].count).toFixed(2);
                        if ((this.OrderMaster.slaves[0].needFry == 1 && this.OrderMaster.typeCode == 'YING_PIAN') || this.OrderMaster.typeCode == 'GAO_FANG' || this.OrderMaster.typeCode == 'WAN_JI') {
                            this.price = Number(this.price) + Number(this.OrderMaster.slaves[0].priceOther * this.OrderMaster.slaves[0].count)
                        }
                        if (this.OrderMaster.diagnoseAmt > 0) {
                            this.price = Number(this.OrderMaster.diagnoseAmt) + Number(this.price)
                        }
                        if (this.OrderMaster.adjustType == 'CUT_PRICE') {
                            this.price = Number(this.price) + -Number(sum * Number(this.OrderMaster.adjustPercent))
                        } else if (this.OrderMaster.adjustType == 'RAISE_PRICE') {
                            this.price = Number(this.price) + Number(sum * Number(this.OrderMaster.adjustPercent))
                        }


                    } else {
                        this.price = sum
                    }

                } else {
                    for (let i of this.OrderMaster.slaves1) {
                        for (let it of i.items) {
                            sum = sum + it.count * it.price / 100
                        }
                    }
                    this.sumPrice = sum;
                    if (sum > 0) {
                        this.price = Number(sum).toFixed(2)
                    } else {
                        this.price = sum
                    }
                    //   this.price = Number(this.price) + Number(this.OrderMaster.slaves[0].priceOther)
                }
                if (this.price > 0) {
                    this.price = Number(this.price).toFixed(2)
                }
            },

            //搜索药材
            querySearch(queryString, cb) {
                if (this.ingredients == '' || this.ingredients == null) {
                    cb(this.list)
                } else if (this.OrderMaster.pharmacyId == '') {
                    this.$message.info('请选择药房')
                    cb(this.list)
                } else if (this.OrderMaster.typeCode == '') {
                    this.$message.info('请选择剂型')
                    cb(this.list)
                } else {
                    let params = new FormData()
                    params.append('pharmacyId', this.OrderMaster.pharmacyId)
                    params.append('medicinalName', this.ingredients)
                    params.append('typeCode', this.OrderMaster.typeCode)
                    params.append('currentPage', 1)
                    params.append('pageSize', 10)
                    this.axios.post('api-b/10005/queryMedicinalMaterialsDisNew', params, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {

                        if (res.data.code === 10000) {
                            this.list = res.data.data.data;
                            for (let i of this.list) {
                                i.value = i.medicinalName
                            }
                        } else {
                            this.$message.error(res.data.message)
                        }
                        if (this.list.length > 0) {
                            cb(this.list)
                        }
                    }).catch(error => {
                        cb(this.list)
                    })
                }
            },
            // 选择药材
            medicinalSelect(item) {
                this.pwjj = []
                this.cjl = []
                this.pwjjVisible = false
                this.ispwjj = false
                if (this.OrderMaster.slaves[0].items.length > 0) {
                    for (let i of this.OrderMaster.slaves[0].items) {
                        if (i.name === item.medicinalName) {
                            this.$message.info("请勿重复添加")
                            this.ingredients = ''
                            return
                        }
                    }
                }
                this.map = {
                    count: item.count,
                    medicineName: item.medicinalName,
                    quantityUnit: item.quantityUnit
                }
                this.map1 = {
                    count: '',
                    isExcess: 0,
                    isTaboo: 0,
                    name: item.medicinalName,
                    pharmacyId: item.pharmacyId,
                    quantityUnit: item.quantityUnit,
                    price: item.price,
                    recommendLimit: -1,
                    stockNo: item.stockNo
                }
                this.map.name = item.medicinalName;
                //  this.SlavePriceNew.items.unshift(this.map)
                this.OrderMaster.slaves[0].items.unshift(this.map1)
                this.ingredients = ''
                this.isSub = true
                this.ispwjj = false;
            },
            // 删除药材
            deleteIngredients(index) {
                this.pwjj = []
                this.cjl = []
                this.pwjjVisible = false
                this.ispwjj = false
                this.OrderMaster.slaves[0].items.splice(index, 1)
                //      this.SlavePriceNew.items.splice(index, 1)
            },
            deleteIngredients1(index) {
                this.OrderMaster.slaves.splice(index, 1)
            },

            // 清空药材
            emptyIngredients() {
                this.pwjj = []
                this.cjl = []
                this.pwjjVisible = false
                this.ispwjj = false
                this.OrderMaster.slaves[0].items = []
                this.SlavePriceNew.items = []
            },
            // 使用处方大全弹窗 获取科目列表
            getBookList() {
                this.axios.get('/api-b/10005/queryMedicineBook?currentPage=1&pageSize=40', {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {

                    if (res.data.code === 10000) {
                        this.bookList = res.data.data.data
                        let all = {
                            id: '',
                            bookName: '全部'
                        }
                        this.bookList.unshift(all)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 使用处方大全弹窗 查询处方大全
            getPrescribe() {
                this.getBookList()


                let params = new FormData();
                params.append("medicineBookId", this.query.bookId)
                params.append("currentPage", this.prescribeNum)
                params.append("pageSize", this.prescribeSize)
                params.append("title", this.query.title)
                this.axios.post('/api-b/10005/queryMedicineBookDetail', params, {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {

                        if (res.data.data !== null) {
                            let data = res.data.data.data
                            this.prescribeTotal = res.data.data.totalCount
                            setTimeout(() => {
                                for (let i = 0; i < data.length; i++) {
                                    data[i].bookName = this.bookList.find(item => {
                                        return data[i].medicineBookId === item.id
                                    }).bookName
                                }
                                this.prescribeData = data
                            }, 300)
                            this.isUsePrescribeVisible = true
                        } else {
                            this.$message.info('暂无处方')
                            this.prescribeData = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.prescribeData = []
                    }
                })
            },
            // 使用处方大全弹窗 查询处方大全换页
            handlePageChange(val) {
                this.prescribeNum = val
                this.getPrescribe()
            },
            // 打卡处方大全详情
            openPrescribeMessage(row) {
                this.prescribeMessage = row.bookRecipeList;
                // this.usePrescribe(row)
                this.prescribeALLVisible = true
            },
            // 处方大全录入
            enterPrescribe() {
                if (this.OrderMaster.pharmacyId === '') {
                    this.$message.error('请先选择药房')
                } else if (this.OrderMaster.typeCode === '') {
                    this.$message.error('请选择处方类型')
                } else {

                    this.usePrescribeAll(this.prescribeMessage)
                }
            },
            // 处方大全列表录入
            enterPrescribeList(data) {
                if (this.OrderMaster.pharmacyId === '') {
                    this.$message.error('请先选择药房')
                } else if (this.OrderMaster.typeCode === '') {
                    this.$message.error('请选择处方类型')
                } else {
                    this.usePrescribeAll(data)
                }
            },
            // 录入处方大全
            usePrescribeAll(data) {
                let params = {
                    count: 1,
                    items: [],
                    needFry: this.OrderMaster.slaves[0].needFry,
                    pharmacyId: this.OrderMaster.pharmacyId,
                    typeCode: this.OrderMaster.typeCode
                }
                for (let i = 0; i < data.length; i++) {
                    let item = {
                        medicineName: data[i].medicineName,
                        count: data[i].number,
                        quantityUnit: "克",
                    }
                    params.items.push(item)
                }
                this.querySlavePriceNewV1(params)

                this.isUsePrescribeVisible = false
                this.prescribeALLVisible = false
            },
            // 使用自备良方
            getMyPrescribe() {
                if (this.OrderMaster.pharmacyId === '') {
                    this.$message.info('请先选择药房')
                } else if (this.OrderMaster.typeCode === '') {
                    this.$message.info('请先选择处方类型')
                } else {
                    let params = new FormData()
                    params.append('name', this.myPrescribeName)
                    params.append('currentPage', this.myPrescribeNum)
                    params.append('pageSize', 10)
                    this.axios.post('/api-b/10005/queryDoctorPrescription/', params, {
                        headers: {
                            Authorization: this.authorization,
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            if (res.data.data.data.length !== 0) {
                                this.myPrescribeList = res.data.data.data
                                this.myPrescribeVisible = true
                            } else {
                                this.$message.info('暂无自备良方')
                                this.myPrescribeList = []
                            }
                            this.myPrescribeTotal = res.data.data.totalCount
                        } else {
                            this.$message.error(res.data.message)
                            this.myPrescribeList = []
                            this.myPrescribeTotal = 0
                        }
                    }).catch(error => {
                        this.myPrescribeList = []
                        this.myPrescribeTotal = 0
                    })
                }
            },
            updateAI() {
                this.smartInquiry.createTime = new Date(this.smartInquiry.createTime)
                this.smartInquiry.gmtCreated = new Date(this.smartInquiry.gmtCreated)
                this.smartInquiry.gmtModified = new Date(this.smartInquiry.gmtModified)

                this.axios.post('/api-s/10044/update/', this.smartInquiry, {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success("保存成功")
                        this.smartInquiry.createTime = new Date(+new Date(this.smartInquiry.createTime) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
                        this.smartInquiry.gmtCreated = new Date(+new Date(this.smartInquiry.gmtCreated) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
                        this.smartInquiry.gmtModified = new Date(+new Date(this.smartInquiry.gmtModified) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
                    } else {
                        this.$message.error(res.data.message)

                    }
                })
            },
            AISpeediness() {
                this.updateAI()
                this.AISpeedinessVisible = false
                let params = {
                    count: 1,
                    items: [],
                    needFry: this.OrderMaster.slaves[0].needFry,
                    pharmacyId: this.OrderMaster.pharmacyId,
                    typeCode: this.OrderMaster.typeCode
                }

                if (undefined != this.bookDetail) {
                    if (this.bookDetail.bookRecipeList.length > 0) {

                        for (let i = 0; i < this.bookDetail.bookRecipeList.length; i++) {
                            let item = {
                                medicineName: this.bookDetail.bookRecipeList[i].medicineName,
                                count: this.bookDetail.bookRecipeList[i].number,
                                quantityUnit: "克",
                            }
                            params.items.push(item)
                        }
                        this.querySlavePriceNewV1(params)
                    }
                    this.OrderMaster.patientComplaint = this.smartInquiry.mainCom + ',' + this.smartInquiry.primSym + ',' + this.smartInquiry.acpnSym
                    this.OrderMaster.doctorDiagnose = this.smartInquiry.synResult + ',' + this.smartInquiry.disResult
                }
                this.queryAIVisible = false
                this.openAIVisible = false

            }
            ,
            NotAISpeediness() {
                this.updateAI()
                this.AISpeedinessVisible = false
                this.queryAIVisible = false
                this.openAIVisible = false
                this.OrderMaster.patientComplaint = this.smartInquiry.mainCom + ',' + this.smartInquiry.primSym + ',' + this.smartInquiry.acpnSym
                this.OrderMaster.doctorDiagnose = this.smartInquiry.synResult + ',' + this.smartInquiry.disResult
            }
            ,
            //查看诊断详情
            openAI(data) {
                this.smartInquiry = {}
                this.bookDetail = {bookRecipeList: []}
                this.queryAIDetails(data)
            }
            ,
            //查询详情
            queryAIDetails(data) {
                let params = new FormData
                params.append("id", data.id)

                this.axios.post('/api-s/10044/selectById/', params, {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {

                    if (res.data.code === 10000) {

                        this.smartInquiry = data
                        this.bookDetail = res.data.data.bookDetail
                        this.openAIVisible = true
                    } else {
                        this.$message.error(res.data.message)

                    }
                })
            }
            ,
            // 查询AI诊断
            queryAI() {
                if (this.OrderMaster.pharmacyId === '') {
                    this.$message.info('请先选择药房')
                } else if (this.OrderMaster.typeCode === '') {
                    this.$message.info('请先选择处方类型')
                } else {
                    this.axios.get('/api-s/10044/100172/' + this.queryAINum + '/10?name=' + this.queryAIName + '&hospitalId=0&state=' + this.AIstate, {
                        headers: {
                            Authorization: this.authorization,
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            if (res.data.data.length !== 0) {
                                this.queryAINum = res.data.data.pageNum
                                this.queryAIList = res.data.data.list
                                this.queryAIVisible = true
                                for (let i of this.queryAIList) {
                                    i.createTime = new Date(+new Date(i.createTime) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
                                    i.gmtCreated = new Date(+new Date(i.gmtCreated) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
                                    i.gmtModified = new Date(+new Date(i.gmtModified) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')

                                }

                            } else {
                                this.$message.info('暂无诊断信息')
                                this.queryAIList = []
                            }

                            this.queryAITotal = res.data.data.total
                        } else {
                            this.$message.error(res.data.message)
                            this.queryAIList = []
                            this.queryAITotal = 0
                        }
                    }).catch(error => {
                        this.queryAIList = []
                        this.queryAITotal = 0
                    })
                }
            },
            // 诊断列表换页
            handleQueryAI(val) {
                this.queryAINum = val
                this.queryAI()
            },
            // 自备良方换页
            handleMyPrescribe(val) {
                this.myPrescribeNum = val
                this.getMyPrescribe()
            },
            // 录入自备良方
            enterMyPrescribe(data) {
                console.log(data)
                if (this.OrderMaster.pharmacyId === '') {
                    this.$message.error('请先选择药房')
                } else if (this.OrderMaster.typeCode === '') {
                    this.$message.error('请选择处方类型')
                } else {
                    let params = {
                        count: 1,
                        items: [],
                        needFry: this.OrderMaster.slaves[0].needFry,
                        pharmacyId: this.OrderMaster.pharmacyId,
                        typeCode: this.OrderMaster.typeCode
                    }
                    let items = []
                    for (let i = 0; i < data.length; i++) {
                        let item = {
                            medicineName: data[i].medicineName,
                            count: data[i].count,
                            quantityUnit: data[i].quantityUnit,
                        }
                        params.items.push(item)
                    }
                    console.log(params)
                    this.querySlavePriceNew(params)
                    this.myPrescribeVisible = false
                }
            },
            //查询药品价格
            querySlavePriceNewV1(params) {
                this.OrderMaster.slaves[0].items = []
                this.SlavePriceNew = {
                    count: 1,
                    doctorId: '',
                    items: [],
                    needFry: this.OrderMaster.slaves[0].needFry,
                    pharmacyId: 0,
                    priceOther: 0,
                    typeCode: ""
                }
                this.axios.post('/api-b/10005/querySlavePriceNewV1/', params, {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    console.log(res)
                    if (res.data.code === 10000) {
                        let list = res.data.data[0].medicinalMaterialsList
                        let outList = res.data.data[0].outMedicinalMaterialsList
                        if (outList.length > 0) {
                            for (let i = 0; i < outList.length; i++) {
                                let drug = {
                                    price: 0,
                                    decoctionMethod: "",
                                    isNull: true,
                                    isExcess: 0,
                                    isTaboo: 0,
                                    name: outList[i].medicinalName,
                                    pharmacyId: 0,
                                    quantityUnit: outList[i].quantityUnit,
                                    recommendLimit: -1,
                                    stockNo: outList[i].stockNo,
                                    count: outList[i].count,
                                }
                                this.OrderMaster.slaves[0].items.push(drug)
                            }
                        }
                        for (let i = 0; i < list.length; i++) {
                            let drug = {
                                price: list[i].price,
                                decoctionMethod: "",
                                isExcess: 0,
                                isTaboo: 0,
                                name: list[i].medicinalMaterialsName,
                                pharmacyId: 0,
                                quantityUnit: list[i].quantityUnit,
                                recommendLimit: -1,
                                stockNo: list[i].stockNo,
                                count: list[i].count,
                            }
                            this.OrderMaster.slaves[0].items.push(drug)
                        }

                        this.$message.success("调用成功")
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }

            ,
            //查询药品价格
            querySlavePriceNew(params) {

                this.SlavePriceNew = {
                    count: 1,
                    doctorId: '',
                    items: [],
                    needFry: this.OrderMaster.slaves[0].needFry,
                    pharmacyId: 0,
                    priceOther: 0,
                    typeCode: ""
                }
                this.axios.post('/api-b/10005/querySlavePriceNew/', params, {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.OrderMaster.slaves[0].items = []
                        let list = res.data.data[0].medicinalMaterialsList
                        let outList = res.data.data[0].outMedicinalMaterialsList
                        if (outList.length > 0) {
                            for (let i = 0; i < outList.length; i++) {
                                let drug = {
                                    price: 0,
                                    decoctionMethod: "",
                                    isNull: true,
                                    isExcess: 0,
                                    isTaboo: 0,
                                    name: outList[i].medicinalName,
                                    pharmacyId: 0,
                                    quantityUnit: outList[i].quantityUnit,
                                    recommendLimit: -1,
                                    stockNo: outList[i].stockNo,
                                    count: outList[i].count,
                                }
                                this.OrderMaster.slaves[0].items.push(drug)
                            }
                        }
                        for (let i = 0; i < list.length; i++) {
                            let drug = {
                                price: list[i].price,
                                decoctionMethod: "",
                                isExcess: 0,
                                isTaboo: 0,
                                name: list[i].medicinalMaterialsName,
                                pharmacyId: 0,
                                quantityUnit: list[i].quantityUnit,
                                recommendLimit: -1,
                                stockNo: list[i].stockNo,
                                count: list[i].count,
                            }
                            this.OrderMaster.slaves[0].items.push(drug)
                        }

                        this.$message.success("调用成功")
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            }
            ,
            // 取消保存自备良方
            cancelAddMyPrescribe() {
                this.savePrescribeVisible = false
                this.$nextTick(() => {
                    this.$refs.addMyPrescribe.clearValidate()
                })
            },
            // 保存自备良方
            saveMyPrescribe() {
                this.$refs.addMyPrescribe.validate(valid => {
                    if (valid) {

                        this.axios.post('/api-b/10036/100124', this.savePrescribeData, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.savePrescribeVisible = false
                                this.$nextTick(() => {
                                    this.$refs.addMyPrescribe.resetFields()
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请填写自备良方名称')
                    }
                })
            },
            // 完成就诊
            finishWork() {
                this.pwjj = []
                this.cjl = []
                //this.pharmacyList = []
                //this.typeCodeList = []
                this.SlavePriceNew = {
                    count: 1,
                    doctorId: '',
                    items: [],
                    needFry: 0,
                    pharmacyId: 0,
                    priceOther: 0,
                    typeCode: ""
                }
                this.prescriptionCost = 0
                if (this.medicineType == 2) {
                    let is = false;
                    let isNull = true;
                    this.$refs.diagnose1.validate(valid => {
                        is = valid;
                    })
                    this.$refs.diagnose2.validate(valid => {
                        if (is === true) {
                            is = valid;
                        }
                    })

                    /*                    if (this.OrderMaster.slaves1.length > 0) {
                                            this.$refs.diagnose4.validate(valid => {
                                                if (is === true) {
                                                    is = valid;
                                                }
                                            })
                                        }*/
                    for (let i of this.OrderMaster.slaves1) {
                        if (i.isNull || i.items[0].count < 1) {
                            isNull = false;
                            break;
                        }
                    }
                    let patientIs = true
                    this.axios.get('api-b/10005/checkSubscribe?userId=' + this.OrderMaster.patientId, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            if (res.data.message !== '该患者已关注') {
                                this.$message.info("患者已取消关注")
                                patientIs = false
                            } else {
                                patientIs = true
                            }
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                    switch (true) {
                        case patientIs === false:
                            break
                        case isNull === false:
                            this.$message.error('药材数量为空或者药材缺货')
                            break
                        case this.OrderMaster.patientId === '':
                            this.$message.error('请选择患者')
                            break
                        case this.OrderMaster.slaves.length === 0:
                            this.$message.error('请选择药材')
                            break
                        case !is:
                            this.$message.error('请按照要求填写相关信息')
                            break
                        default:
                            this.OrderMaster.slaves = this.OrderMaster.slaves1
                            this.productExtractionVisible = true;
                            break
                    }
                } else {
                    let is = false;
                    let isNull = true;
                    this.$refs.diagnose1.validate(valid => {
                        is = valid;
                    })
                    this.$refs.diagnose2.validate(valid => {
                        if (is === true) {
                            is = valid;
                        }
                    })
                    this.$refs.diagnose3.validate(valid => {
                        if (is === true) {
                            is = valid;
                        }
                    })
                    /*if (this.OrderMaster.slaves[0].items.length > 0) {
                        this.$refs.diagnose4.validate(valid => {
                            if (is === true) {
                                is = valid;
                            }
                        })
                    }*/
                    for (let i of this.OrderMaster.slaves[0].items) {
                        if (i.isNull || i.count < 1) {
                            isNull = false;
                            break;
                        }
                    }
                    let patientIs = true
                    this.axios.get('api-b/10005/checkSubscribe?userId=' + this.OrderMaster.patientId, {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            if (res.data.message !== '该患者已关注') {
                                this.$message.info("患者已取消关注")
                                patientIs = false
                            } else {
                                patientIs = true
                            }
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                    switch (true) {
                        case patientIs === false:
                            break
                        case isNull === false:
                            this.$message.error('药材数量为空或者药材缺货')
                            break
                        case this.OrderMaster.patientId === '':
                            this.$message.error('请选择患者')
                            break
                        case this.OrderMaster.slaves[0].items.length === 0:
                            this.$message.error('请选择药材')
                            break
                        case !is:
                            this.$message.error('请按照要求填写相关信息')
                            break
                        default:
                            switch (this.OrderMaster.typeCode) {
                                case "GAO_FANG":
                                    this.typeCode = '四季膏方'
                                    break
                                case "KE_LI":
                                    this.typeCode = '颗粒'
                                    break
                                case "YING_PIAN":
                                    this.typeCode = '饮片'
                                    break
                                case "WAN_JI":
                                    this.typeCode = '丸剂'
                                    break
                            }


                            let sumCount = 0;
                            this.SlavePriceNew.typeCode = this.OrderMaster.typeCode
                            this.OrderMaster.slaves[0].typeCode = this.OrderMaster.typeCode
                            this.SlavePriceNew.pharmacyId = this.OrderMaster.pharmacyId
                            this.SlavePriceNew.doctorId = this.doctorId
                            this.SlavePriceNew.needFry = this.OrderMaster.slaves[0].needFry
                            for (let i = 0; i < this.OrderMaster.slaves[0].items.length; i++) {
                                let item = {
                                    medicineName: this.OrderMaster.slaves[0].items[i].name,
                                    count: this.OrderMaster.slaves[0].items[i].count,
                                    quantityUnit: "克",
                                }
                                this.SlavePriceNew.items.push(item)
                                sumCount = Number(this.OrderMaster.slaves[0].items[i].count) + Number(sumCount);
                            }
                            if ((this.OrderMaster.typeCode == 'GAO_FANG' || this.OrderMaster.typeCode == 'WAN_JI') && Number(this.pharmacy.minMake) > Number(sumCount)) {
                                this.$message.info("剂量小于" + this.pharmacy.minMake)
                            } else {
                                this.OrderMaster.slaves[0].pharmacyId = this.OrderMaster.pharmacyId
                                this.axios.post('api-b/10005/querySlavePriceNew', this.SlavePriceNew, {
                                    headers: {
                                        Authorization: this.authorization
                                    }
                                }).then(res => {
                                    if (res.data.code === 10000) {
                                        if ((this.OrderMaster.slaves[0].needFry == 1 && this.OrderMaster.typeCode == 'YING_PIAN') || this.OrderMaster.typeCode == 'GAO_FANG' || this.OrderMaster.typeCode == 'WAN_JI') {

                                            this.OrderMaster.slaves[0].priceOther = res.data.data[0].priceOther
                                        }
                                    } else {
                                        this.$message.error(res.data.message)
                                    }
                                })
                                let medicinal = false
                                for (let i = 0; i < this.OrderMaster.slaves[0].items.length; i++) {
                                    if (this.OrderMaster.slaves[0].items[i].id === '' || this.OrderMaster.slaves[0].items.id === null) {
                                        medicinal = true
                                        break
                                    }
                                }
                                if (!this.ispwjj) {

                                    this.axios.post('api-b/10005/v1/checkmedicinalMaterials', this.SlavePriceNew, {
                                        headers: {
                                            Authorization: this.authorization
                                        }
                                    }).then(res => {
                                        if (res.data.code === 10000) {
                                            console.log(res.data.data)
                                            for (let i = 0; i < res.data.data.length; i++) {

                                                let a = {
                                                    isTabooMedicinal: res.data.data[i].isTabooMedicinal,
                                                    medicineName: res.data.data[i].medicineName,
                                                    recommendLimit: res.data.data[i].recommendLimit
                                                }
                                                if (res.data.data[i].isExcess != null) {
                                                    this.OrderMaster.slaves[0].items[i].isExcess = res.data.data[i].isExcess
                                                } else {
                                                    this.OrderMaster.slaves[0].items[i].isExcess = 0;
                                                }
                                                if (res.data.data[i].isTaboo != null) {
                                                    this.OrderMaster.slaves[0].items[i].isTaboo = res.data.data[i].isTaboo
                                                } else {
                                                    this.OrderMaster.slaves[0].items[i].isTaboo = 0
                                                }
                                                if (res.data.data[i].recommendLimit > 0) {
                                                    this.cjl.push(a)
                                                }
                                                if (res.data.data[i].isTaboo == 1) {
                                                    this.pwjj.push(a)
                                                }
                                            }
                                            if (this.pwjj.length <= 0 && this.cjl.length <= 0) {
                                                this.detailVisible = true
                                            } else {
                                                this.pwjjVisible = true;

                                            }

                                        } else {
                                            this.$message.error(res.data.message)
                                        }
                                    }).catch(error => {
                                        this.$message.error(res.data.message)
                                    })
                                } else {
                                    this.detailVisible = true

                                }
                            }

                    }
                }
            },

            writePrescriptionV2() {
                this.OrderMaster.isOnline = 1;
                this.axios.post('/api-b/10005/v2/storeOrder', this.OrderMaster, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.detailVisible = false;
                        this.writePrescriptionTypeVisible = false
                        this.productExtractionVisible = false;
                        /*                    this.$nextTick(() => {
                                                setInterval(location.reload(), 5000);
                                            })*/

                        this.clearData();
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(error => {
                    this.$message.error(res.data.message)
                })
            },
            // 确认开方
            writePrescription() {

                this.axios.post('/api-b/10005/v1/storeOrder', this.OrderMaster, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.detailVisible = false;
                        this.writePrescriptionTypeVisible = false
                        this.productExtractionVisible = false;
                        /*                    this.$nextTick(() => {
                                                setInterval(location.reload(), 5000);
                                            })*/

                        this.clearData();
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(error => {
                    this.$message.error(res.data.message)
                })
            },
            clearData() {
                this.ingredients = ''
                this.OrderMaster = {
                    adjustDesc1: '免费',
                    adjustDesc: '免费',
                    diagnoseAmt: 0,
                    diagnoseAmt1: 0,
                    diagnoseAmtType: "FREE",
                    doctorAdvice: '',
                    doctorDiagnose: '',
                    doctorId: this.doctorId,
                    doctorMessage: "",
                    hiddenContent: "HIDDEN_NO",
                    hiddenDetail: 2,
                    isOnline: "",
                    orderType: 1,
                    patientAge: '',
                    patientComplaint: "",
                    patientId: '',
                    patientName: '',
                    patientPregnant: 2,
                    patientSex: 1,
                    pharmacyId: '',
                    slaves: [
                        {
                            autograph: '',
                            categoryCode: "",
                            count: 1,
                            items: [],
                            needFry: this.OrderMaster.slaves[0].needFry,
                            orderUsage: '',
                            packageManner: "",
                            pharmacyId: '',
                            priceOther: 0.0,
                            takeDays: '',
                            takingState: '',
                            typeCode: ''
                        }

                    ], slaves1: [],
                    status: 0,
                    typeCode: ''
                }
                this.patient = ''
                this.active = ''
                this.pwjj = []
                this.cjl = []
                this.pharmacyList = []
                this.typeCodeList = []
                this.price = 0
            }
            ,
            medicineTypeClick(data) {

                this.medicineType = data;
                this.active = ''
                this.pwjj = []
                this.cjl = []
                this.pharmacyList = []
                this.typeCodeList = []
                this.ingredients = ''
                this.OrderMaster.pharmacyId = ''
                this.OrderMaster.pharmacy = ''
                this.OrderMaster.typeCode = ''
                this.OrderMaster.orderType = data
                this.OrderMaster.slaves = [
                    {
                        autograph: '',
                        categoryCode: "",
                        count: 1,
                        items: [],
                        needFry: this.OrderMaster.slaves[0].needFry,
                        orderUsage: '',
                        packageManner: "",
                        pharmacyId: '',
                        priceOther: 0.0,
                        takeDays: '',
                        takingState: '',
                        typeCode: ''
                    }

                ]
                this.OrderMaster.orderUsage = ''
                this.OrderMaster.slaves1 = []
            },
        },
        mounted() {
            this.$nextTick(() => {
                setInterval(this.getTime, 1000);
            })
            this.$nextTick(() => {
                setInterval(this.getPrice, 1000);
            })
        }
        ,
        watch: {
            search: {
                handler() {
                    clearTimeout(this.timeout);
                    this.prescribeNum = 1
                    this.timeout = setTimeout(() => {
                        this.getData()
                    }, 300);
                }
            },
            active: {
                handler() {
                    if (this.active !== '') {
                        // this.queryByTypeCode()
                    }
                }
            },
            query: {
                handler() {
                    clearTimeout(this.timeout);
                    this.prescribeNum = 1
                    this.timeout = setTimeout(() => {
                        this.getPrescribe()
                    }, 300);
                },
                deep: true
            },
        }
    };
</script>

<style>
    .el-divider--horizontal {
        margin-top: 0;
    }

    .el-radio {
        margin-right: 20px;
    }

    :focus {
        outline: none;
    }

    .el-drawer__header > :first-child {
        margin-top: -20px;
    }

    .el-drawer__header {
        height: 34px;
        background: rgba(97, 167, 255, 1);
        margin-bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
    }

    .el-drawer__close-btn {
        margin-top: -20px;
        color: #FFFFFF;
        font-size: 14px;
    }

    .el-scrollbar {
        padding-bottom: 20px;
    }

    body .el-scrollbar__wrap {
        overflow-x: hidden;
        margin-bottom: 20px;
    }

    .add-dialog {
        margin: 0 !important;
        position: absolute;
        right: 0;
        top: 0;
        min-width: 900px !important;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }

    .el-dialog__body {
        transform: translate3d(0, 0, 0);
        overflow: auto;
    }

    .dialog-foot-bottom {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }
</style>
<style scoped>
    .SD_dialog .el-dialog__body, .P_dialog .el-dialog__body {
        padding-bottom: 16px;
    }

    .SD_dialog .el-dialog__footer, .P_dialog .el-dialog__footer, .h_dialog .el-dialog__footer {
        border-top: 1px solid #EEEEEE;
        padding-bottom: 10px;
    }
</style>

<style scoped>
    .person {
        padding: 10px;
        margin-bottom: 10px;
        background-color: #FFFFFF;
        overflow: hidden;
    }

    .person_p {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        float: left;
        background-size: cover;
        margin-right: 10px;
    }

    .person_i {
        padding: 6px 0;
        font-size: 14px;
    }

    .person_i p {
        line-height: 1;
        color: #333333;
        margin-bottom: 18px;
    }

    .person_i span {
        line-height: 1;
        color: #666666;
    }

    .recipe .el-form-item, .el-footer .el-form-item {
        margin-bottom: 10px;
    }

    .footer_btn {
        width: 180px;
        display: flex;
        justify-content: space-around;
    }

    .footer_btn span {
        display: block;
        width: 80px;
        height: 80px;
        border-radius: 8px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .recipe_box p, .print_box p {
        padding: 10px 0;
        font-size: 14px;
        line-height: 20px;
    }

    .print_box_footer p {
        display: flex;
        justify-content: space-between;
    }

    .print_box_footer p span {
        display: block;
        width: 33.3%;
    }

    .history_box p {
        padding: 10px 0;
    }

    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }

    .aside-box {
        display: flex;
        flex-direction: column;
        box-shadow: 1px 0 0 0 rgba(238, 238, 238, 1);
    }

    .el-aside {
        margin-top: -9px;
        margin-left: -10px;
        background: rgba(246, 246, 246, 1);
        height: 920px;
    }

    .search-box {
        display: flex;
        flex-direction: row;
        margin: 10px;
    }

    .dialog-set {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }

    .handle-select {
        width: 120px;
    }

    .patient-box {
        margin: 0 10px 10px 10px;
        width: 280px;
        height: 68px;
        background: rgba(242, 242, 242, 1);
        border-radius: 4px;
        border: 1px solid rgba(227, 227, 227, 1);
    }

    .patient-box:hover {
        background: rgba(240, 246, 255, 1);
        border: 1px solid rgba(97, 167, 255, 1);
        -moz-user-select: none; /*火狐*/
        -webkit-user-select: none; /*webkit浏览器*/
        -ms-user-select: none; /*IE10*/
        user-select: none;
    }

    .patient-box-in {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        margin: 10px 0 0 10px;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
    }

    .active {
        background: rgba(240, 246, 255, 1);
        border: 1px solid rgba(97, 167, 255, 1);
    }

    .mr10 {
        margin-left: 10px;
    }

    .mr20 {
        margin-left: 20px;
    }

    .mr30 {
        margin-left: 30px;
    }

    .mr60 {
        margin-left: 60px;
    }

    .flex-box {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        margin-bottom: 14px;
        margin-right: 10px
    }

    .money {
        font-size: 18px;
        font-weight: 600;
        color: rgba(255, 148, 89, 1);
    }

    .record {
        display: flex;
        flex-direction: row;
        height: 861px;
        border: 1px solid rgba(227, 227, 227, 1);
    }

    .record-aside {
        transform: translate3d(0, 0, 0);
        overflow: auto;
        padding: 10px;
        min-height: 825px;
        width: 276px;
        background: rgba(246, 246, 246, 1);
    }

    .record-patient-box {
        padding: 10px 0 10px 10px;
        background: rgba(242, 242, 242, 1);
        border-radius: 4px;
        border: 1px solid rgba(227, 227, 227, 1);
        font-size: 14px;
        margin: 10px 0 0;
        color: rgba(102, 102, 102, 1);
    }

    .record-flex-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
    }

    .recordActive {
        background: rgba(240, 246, 255, 1);
        border: 1px solid rgba(97, 167, 255, 1);
    }

    .record-main {
        transform: translate3d(0, 0, 0);
        overflow: auto;
        width: 580px;
        padding: 10px;
    }

    .line {
        height: 1px;
        width: 100%;
        background: #EEEEEE;
    }

    .select-box {
        display: flex;
        flex-direction: row;
        height: 36px;
        line-height: 36px;
        margin-top: -25px;
        font-size: 14px;
        margin-bottom: 10px;
    }

    .select {
        padding: 0 15px;
        /*width: 80px;*/
        text-align: left;
    }

    .selectActive {
        box-shadow: 0 2px 0 rgba(97, 167, 255, 1);
        color: rgba(97, 167, 255, 1);
    }

    .selectActive1 {
        box-shadow: 0 2px 0 rgba(97, 167, 255, 1);
        color: rgba(97, 167, 255, 1);
    }
</style>
